export const LANG_IT_NAME = 'italian';
export const LANG_IT_TRANS = {
  'Loading': 'Caricamento in corso',
  'Dashboard': 'Pannello di controllo',
  'My Equipment': 'La mia attrezzatura',
  'My Inventory': 'Il mio inventario',
  'Reports': 'Rapporti',
  'Admin': 'Admin',
  'TT Admin': 'TT Admin',
  'My Account': 'Il mio account',
  'Help': 'Aiuto',
  'Inspections': 'ispezioni',
  'New Inspection': 'nuova ispezione',
  'Find & Edit Inspection': 'Trova & Modifica Inspection',
  'Interpret Inspection': 'interpretare ispezione',
  'Inspection Planning': 'Pianificazione di ispezione',
  'Download Android App': 'Scarica Android App',
  'Full History': 'Storia completa',
  'Record an Action': 'Registrare un\'azione',
  'Meter Reading': 'Lettura contatori',
  'Meter Change': 'Meter Change',
  'Setup New Equipment': 'Impostazione nuove apparecchiature',
  'Find & Edit Equipment': 'Trova & Modifica attrezzature',
  'Relocate Equipment': 'Trasloco Attrezzature',
  'Inventory': 'Inventario',
  'New Chain or Frame': 'Nuova catena o frame',
  'Inspection Analysis': 'Analisi di ispezione',
  'Component Life Performance': 'Prestazioni Vita Componente',
  'Equipment Without Contacts': 'Apparecchiatura senza contatti',
  'Login Statistics': 'Accedi Statistics',
  'Fleet Component Forecast': 'Fleet Previsione Componente',
  'Home': 'Casa',
  'Customer Contacts': 'clienti Contatti',
  'User Contacts': 'User Contatti',
  'Job Roles': 'ruoli di lavoro',
  'Components': 'componenti',
  'COMPONENTS': 'COMPONENTI',
  'Equipment': 'attrezzatura',
  'Branded Styles': 'Stili di marca',
  'Old Setup': 'vecchio Setup',
  'Preferences': 'Preferenze',
  'Logout': 'Disconnettersi',
  'TrackCommander Documentation': 'TrackCommander Documentazione',
  'What\'s New': 'Cosa c\'è di nuovo',
  'About': 'Di',
  'Job Role Setup': 'Impostazione Ruolo Lavoro',
  'Job Role Permissions': 'Permessi di lavoro Ruolo',
  'Job Role Members': 'Membri Job Role',
  'Position & Job Status': 'Posizione & Stato lavoro',
  'Component Types': 'Tipi di componenti',
  'Setup Components': 'di installazione di componenti',
  'Wear Limits (A,B,C,X),': 'Limiti di usura, (A, B, C, X),',
  'Wear Rate Formulas': 'Indossare Formule Tasso',
  'Setup Families': 'Famiglie di configurazione',
  'Setup Makes': 'rende la configurazione',
  'Setup Models': 'I modelli di configurazione',
  'Customer': 'Cliente',
  'User': 'Utente',
  'Search': 'Ricerca',
  'Job Site': 'Sito di lavoro',
  'Equipment Serial/Unit No': 'Equipaggiamento di serie / Unità No',
  'Family': 'Famiglia',
  'Make': 'Rendere',
  'Model': 'Modello',
  'Fleet Overview': 'Fleet Panoramica',
  'Filter': 'Filtro',
  'Filter Table': 'Filtro Tabella',
  'Eval (L)': 'Eval (L)',
  'Eval (R)': 'Eval (R)',
  'Serial No.': 'Numero di serie.',
  'Unit No.': 'Unità N.',
  'SMU': 'SMU',
  'LTD': 'LTD',
  'Last Inspection Date': 'Ultima data ispezione',
  'Last Inspect Date': 'Ultima data ispezione',
  'Back': 'Indietro',
  'Awaiting Interpretation': 'In attesa di Interpretazione',
  'This machine has recently been inspected, but the report is not ready. Once interpreted, your PDF report will be available for download.': 'Questa macchina è stata recentemente ispezionato, ma il rapporto non è pronto. Una volta interpretato, il report PDF sarà disponibile per il download.',
  'Equipment Details': 'DETTAGLI',
  'Download Report': 'Scarica il rapporto',
  'Inspection Details': 'Dettagli ispezione',
  'Find Inspection': 'Trova ispezione',
  'Equipment History': 'Storia Strumento',
  'Record Action': 'Record Azione',
  'Serial Number': 'Numero di serie',
  'Unit Number': 'Numero di unità',
  'N/A': 'N / A',
  'Meter Reading (SMU)': 'Meter Reading (SMU)',
  'Life to Date (LTD)': 'La vita to Date (LTD)',
  'Chain Serial Number (left)': 'Catena Numero di serie (a sinistra)',
  'Frame Serial Number (left)': 'Telaio Numero di serie (a sinistra)',
  'Chain Serial Number (right)': 'Catena Numero di serie (a destra)',
  'Frame Serial Number (right)': 'Telaio Numero di serie (a destra)',
  'Left Side Components': 'Componenti lato sinistro',
  'Worn (%)': 'Logoro (%)',
  'Component': 'Componente',
  'Part No.': 'Codice componente',
  'Life Lived (CMU)': 'La vita vissuta (CMU)',
  'Remaining Life (100%)': 'La vita residua (100%)',
  'Remaining Life (120%)': 'La vita residua (120%)',
  'Install Date': 'data di installazione',
  'Equipment SMU at Install': 'Attrezzatura SMU al momento dell\'installazione',
  'Component Hours at Install': 'Componente Ore al momento dell\'installazione',
  'Right Side Components': 'Componenti lato destro',
  'Ruler': 'Righello',
  'Create Favourite': 'creare preferita',
  'Component Overview': 'Panoramica dei componenti',
  'Wear Rate Overview': 'Tasso di usura Panoramica',
  'Recommendation': 'Raccomandazione',
  'Status': 'Stato',
  'Position': 'Posizione',
  'Type': 'genere',
  'Track Roller Values -': 'Valori rotella -',
  'Left': 'Sinistra',
  'Right': 'Destra',
  'hrs': 'ore',
  'No': 'No',
  'Yes': 'sì',
  'Carrier Roller AVG': 'Roller Carrier AVG',
  'Track Roller AVG': 'Rotella AVG',
  'Track Roller Worst': 'Rotella peggiore',
  'Outstanding Actions': 'azioni in circolazione',
  'Sprocket': 'rocchetto',
  'Rear Idler': 'Idler posteriore',
  'Front Idler': 'tenditore anteriore',
  'Shoe': 'Scarpa',
  'Bush Turned': 'Bush Turned',
  'Bush': 'cespuglio',
  'Hours on Link': 'Ore link',
  'Link': 'collegamento',
  'Current SMU/Hourmeter': 'Corrente SMU / contaore',
  'Site': 'Posto',
  'Unit': 'Unità',
  'Serial': 'Seriale',
  'Update to Current Selection': 'Aggiornamento alla selezione corrente',
  'Setup Undercarriage': 'Impostazione Carro',
  'On Equipment': 'on Equipment',
  'In Inventory': 'in inventario',
  'Setup User': 'Configurazione utente',
  'Setup Customer': 'Configurazione cliente',
  'Setup Job Site': 'Configurazione del sito Job',
  'Observation Lists': 'liste di osservazione',
  'Measurement Points': 'punti di misura',
  'Switch App': 'Interruttore App',
  'Dashboard Overview': 'Dashboard Panoramica',
  'Enlarge': 'Ingrandire',
  'Inspections Performed': 'Controlli effettuati',
  'Total cost of all repairs recorded each month for the past year. This does not include cost of new equipment or parts. Filter this data down using the search above.': 'costo totale di tutte le riparazioni registrate ogni mese per l\'anno passato. Questo non include il costo di nuove apparecchiature o di parti. Filtrare questi dati verso il basso con la ricerca qui sopra.',
  'Total Cost of Repairs': 'Costo totale delle riparazioni',
  'The current evaluation of all the components you can view based on their last inspection. Filter this data down using the search above.': 'La valutazione corrente di tutti i componenti è possibile visualizzare in base alla loro ultima ispezione. Filtrare questi dati verso il basso con la ricerca qui sopra.',
  'Inspections are due by today date. This is based on what you searched for in total and not what you see in this page only.': 'Le ispezioni sono dovute in base alla data di oggi. Questo si basa su quello che hai cercato in totale e non quello che si vede solo in questa pagina.',
  'Inspections due': 'ispezioni dovuti',
  'undefined': 'non definito',
  'Next Inspection Date': 'Prossima Data ispezione',
  'Last Inspection SMU/Hourmeter': 'Ultima ispezione SMU / contaore',
  'SMU/Hourmeter': 'SMU / contaore',
  'Fleet Condition': 'Fleet Condizioni',
  'Equipment Overview': 'attrezzature generali',
  'Meter Reading (SMU/HourMeter)': 'Meter Reading (SMU / contaore)',
  'Setup Date': 'Regolazione data',
  'Details': 'Dettagli',
  'Edit': 'modificare',
  'Interpret': 'Interpretare',
  'Inspection History': 'Storia di ispezione',
  'Change Meter Unit': 'Change Meter Unità',
  'Update Meter': 'Meter Aggiornamento',
  'Life Lived': 'vita vissuta',
  'Equipment SMU/Hourmeter at Install': 'Attrezzature SMU / Contaore a Install',
  'Date Installed': 'data di installazione',
  'Total Component Repairs Cost (inc. All Components Ever)': 'Totale Riparazioni componente di costo (inc. Tutti i componenti di sempre)',
  'Total Purchase Cost (inc. Current Components)': 'Totale costo di acquisizione (inc. Componenti corrente)',
  'Right Side Frame': 'Destra telaio laterale',
  'Right Side Chain': 'Catena Lato destro',
  'Left Side Frame': 'Telaio laterale sinistro',
  'Left Side Chain': 'Catena Lato sinistro',
  'PDF Report': 'PDF report',
  'Tasks': 'Compiti',
  'Change Jobsite': 'Cambio Cantiere',
  'Setup Equipment': 'Attrezzature di installazione',
  'Next Inspection': 'Successivo ispezione',
  'Brand': 'Marca',
  '(CMU)': '(CMU)',
  '(100% Worn)': '(100% Usura)',
  '(120% Worn)': '(120% Worn)',
  'Purchase Cost': 'Costo di acquisto',
  'Repairs Cost': 'riparazioni Costo',
  'Interpretation': 'Interpretazione',
  'Manage Equipment': 'gestire Attrezzature',
  'Meter Reading (SMU/Hourmeter)': 'Meter Reading (SMU / Contaore)',
  'Forward Travel Km': 'Forward Viaggi Km',
  'Reverse Travel Km': 'Reverse Viaggi Km',
  'Forward Hours': 'Ore a termine',
  'Reverse Hours': 'Ore Reverse',
  'JobSite Comment': 'JobSite Commento',
  'Inspection Comment': 'Ispezione Commento',
  'Inspector': 'Ispettore',
  'Inspection Date': 'Ispezione Data',
  'Track Sag': 'Traccia Sag',
  'Cannon Ext.': 'Cannon Ext.',
  'Dry Joints': 'giunti a secco',
  'Scallop': 'Pettine',
  'Add Comment': 'Aggiungi un commento',
  'Interpretation Comment': 'interpretazione Commento',
  'Create New Quote': 'Crea nuovo Citazione',
  'There are currently no quotes.': 'Al momento non ci sono citazioni.',
  'Quotes': 'Citazioni',
  'Bar Chart': 'Grafico a barre',
  'Additional Observations': 'Le osservazioni aggiuntive',
  'Audit Log': 'Registro di audizione',
  'Quote': 'Citazione',
  'Release': 'pubblicazione',
  'Release Report to Customer': 'Rilasciare Relazione al Cliente',
  'PDF': 'PDF',
  'Depth Gauge': 'Profondimetro',
  'UT': 'UT',
  'Eval': 'Eval',
  'Change tool': 'cambio utensile',
  'Add photo': 'Aggiungi foto',
  'CMU': 'CMU',
  'Tool': 'Strumento',
  'Residual Life': 'La vita residua',
  'Select Customer': 'Seleziona cliente',
  'Select Filter': 'selezionare Filtro',
  'Customer Notes': 'Note clienti',
  'Add New': 'Aggiungere nuova',
  'Address To Customer Name': 'Indirizzo Per Nome cliente',
  'Created Date': 'Data di Creazione',
  'Notes': 'Gli appunti',
  'Created By': 'Creato da',
  'Select Job Site': 'Selezionare Job Site',
  'Select Equipment': 'Seleziona attrezzatura',
  'Next': 'Il prossimo',
  'Save And Interpret': 'Salva e interpretare',
  'Change Equipment': 'Attrezzature Change',
  'Review & Save': 'Review & Save',
  'General Information': 'Informazione generale',
  'Abrasive *': 'abrasivo *',
  'Impact *': 'Impact *',
  'Moisture *': 'L\'umidità *',
  'Packing *': 'Imballaggio *',
  'Observations': 'osservazioni',
  'Reverse Travel Kms': 'Reverse Km di viaggio',
  'Reverse Travel hrs': 'ore marcia indietro',
  'Inspection Date *': 'Ispezione Data *',
  'Meter Reading(SMU/Hourmeter) *': 'Meter Reading (SMU / Contaore) *',
  'Inches': 'Pollici',
  'Change Measurement Unit': 'Cambio Unità di misura',
  'Photo': 'Foto',
  'Comment': 'Commento',
  'Equipment Hours': 'Ore Attrezzatura',
  'Forward Travel hrs': 'ore avanti di viaggio',
  'Forward Travel Kms': 'Forward Km di viaggio',
  'Overall Notes': 'Note In generale',
  'Inspection Notes': 'Note di ispezione',
  'Jobsite Notes': 'Note cantiere',
  'Underfoot Conditions': 'condizioni del terreno',
  'Left Chain': 'catena di sinistra',
  'Right Chain': 'catena Destra',
  'Left Frame': 'frame di sinistra',
  'Right Frame': 'Telaio destro',
  'Worn(%)': 'Logoro(%)',
  'Measurement': 'misurazione',
  'MM': 'MM',
  'There are currently no recommendations added for this quote.': 'Al momento non ci sono raccomandazioni aggiunto per questa citazione.',
  'Calipers': 'Calibri',
  'Pos.': 'Pos.',
  'Pos': 'Pos',
  'Worn': 'Logoro',
  'Unsynced Inspections': 'Le ispezioni non sincronizzato',
  'Workshop Repair Estimates': 'Officina di riparazione stime',
  'Evaluation': 'Valutazione',
  'Select Model': 'Seleziona modello',
  'Select Make': 'Seleziona Marchio',
  'Jobsite': 'Sito di lavoro',
  'Condition': 'Condizione',
  'Actions': 'Azioni',
  'How often will you be inspecting this equipment? We will use this to help forecast future inspections.': 'Quanto spesso si sarà ispeziona questo apparecchio? Useremo questo per aiutare le future ispezioni di previsione.',
  'Hours per Day': 'Ore al giorno',
  'Inspection Planner': 'Planner ispezione',
  'I will inspect every': 'Io ispezionare ogni',
  'On average how many days is this equipment in use, and on which days?': 'In media quanti giorni è questa apparecchiatura in uso, e in quali giorni?',
  'Sat': 'Sat',
  'Mon': 'Mon',
  'Tue': 'mar',
  'Wed': 'sposare',
  'Thu': 'gio',
  'Fri': 'Fri',
  'Sun': 'Sun',
  'New SMU/Hourmeter': 'Nuovo SMU / contaore',
  'What is the old SMU/Hourmeter meter reading?': 'Qual è la vecchia lettura del contatore SMU / contaore?',
  'What is the new meter SMU/Hourmeter reading?': 'Qual è la nuova lettura SMU / contaore metro?',
  'What is the date of the replacement?': 'Qual è la data della sostituzione?',
  'Old SMU/Hourmeter Reading is required': 'Vecchio SMU / contaore Reading è necessaria',
  'Application': 'Applicazione',
  'Ranking': 'classifica',
  'Machine Status': 'Stato macchina',
  'Please select the customer and job site where this equipment is located.': 'Si prega di selezionare la sede del cliente e di lavoro in cui si trova questa apparecchiatura.',
  'Create Equipment': 'creare Attrezzature',
  'Would you like to setup a new equipment or modify an existing one?': 'Volete impostare una nuova apparecchiatura o modificare uno esistente?',
  'Modify Existing Equipment': 'Modificare le attrezzature esistenti',
  'How do you identify this equipment?': 'Come si fa a identificare questo apparecchio?',
  'What type of equipment is this?': 'Che tipo di attrezzatura è questo?',
  'What is the earliest known SMU/Hourmeter and the date of reading for this equipment?': 'Qual è il più antico SMU / Contaore e la data di lettura per questa apparecchiatura?',
  'You can attach a photo of this equipment which can be seen throughout the application.': 'È possibile allegare una foto di questa apparecchiatura che può essere visto in tutta l\'applicazione.',
  'You can also set some aditional details, although this is not required.': 'È inoltre possibile impostare alcuni dettagli adizionale, anche se questo non è necessario.',
  'Select Customer & Job Site': 'Selezionare Clienti e del sito Job',
  'Additional Information': 'Informazioni aggiuntive',
  'Serial / Unit Number': 'Numero di serie / Unità',
  'SMU/Hourmeter at Setup': 'SMU / contaore al Setup',
  'LTD at Setup': 'LTD in Impostazioni',
  'Equipment Setup': 'Impostazione attrezzature',
  'Setup Complete!': 'Configurazione completa!',
  'Now that you have setup your equipment, you need to setup the undercarriage for it before you can start recording inspections.': 'Ora che aver installato l\'apparecchiatura, è necessario impostare il sottocarro per esso prima di poter iniziare le ispezioni di registrazione.',
  'Setup Undercarriage for This Equipment': 'Carro di installazione di queste apparecchiature',
  'Setup Another Equipment': 'Imposta un altro apparecchio',
  'Equipment is not selected!': 'Attrezzatura non è selezionata!',
  'Chain & Frame Details': '& Della catena riquadro dei dettagli',
  'Life(When installed on equipment)': 'La vita (quando installato su attrezzature)',
  'SMU/HourMeter and Date validation passed!': 'SMU / contaore e data passata convalida!',
  'Date(When installed on equipment)': 'Data (Una volta installato su attrezzature)',
  'Equipment SMU/Hourmeter (at install)': 'Attrezzature SMU / contaore (in fase di installazione)',
  'Review and Save': 'Review e Salva',
  'This will setup components on both sides of the undercarriage the same, you can view and edit sides indivdually if they are different': 'Questo componenti programma di installazione su entrambi i lati del sottocarro dello stesso, è possibile visualizzare e modificare le parti indivdually se sono diversi',
  'Chain': 'Catena',
  'Please add the components which will go on the chain.': 'Si prega di aggiungere i componenti che andranno sulla catena.',
  'Grouser': 'costola',
  'Please add the components which will go on the frame.': 'Si prega di aggiungere i componenti che andranno sul telaio.',
  'Cost': 'Costo',
  'Validation failed': 'Validazione fallita',
  'Bushing': 'Boccola',
  'Budget Life': 'vita budget',
  'Size': 'Taglia',
  'Frame': 'Telaio',
  'Idler': 'fannullone',
  'Guard': 'Guardia',
  'Track Elongation': 'Traccia Allungamento',
  'Carrier Roller': 'Roller Carrier',
  'Track Roller': 'rotella',
  'Hours at Install': 'Ore a installare',
  'Date at Install': 'Data al momento dell\'installazione',
  'Equip. SMU/Hourmeter at install': 'Equip. SMU / contaore durante l\'installazione',
  'Setup Undercarriage on Equipment': 'Carro di installazione on Equipment',
  'Hrs': 'hrs',
  'Submit': 'Sottoscrivi',
  'Unlock': 'Sbloccare',
  'Validation failed!': 'Validazione fallita!',
  'Hours at install': 'Ore a installare',
  'By changing equipment you will lose all your inputs!': 'Cambiando attrezzature si perderanno tutti i tuoi ingressi!',
  'Validation Passed.': 'Convalida Passed.',
  'Component attached to the system successfully!': 'Componente collegato al sistema con successo!',
  'After you have submitted the data first time round, you are unable to setup components on both sides': 'Dopo aver presentato i dati prima volta, non si riesce a componenti di installazione su entrambi i lati',
  'The current evaluation of all the equipment you can view based on their last inspection. Filter this data down using the search above.': 'La valutazione corrente di tutta l\'apparecchiatura è possibile visualizzare in base alla loro ultima ispezione. Filtrare questi dati verso il basso con la ricerca qui sopra.',
  'Actions Required': 'azioni richieste',
  'Total count of undercarriage inspections performed on a month by month basis. Filter this data down using the search above.': 'Conteggio totale delle ispezioni del sottocarro eseguita su una base mensile. Filtrare questi dati verso il basso con la ricerca qui sopra.',
  'JobSite is not selected!': 'JobSite non è selezionata!',
  'Create new system': 'Creare nuovo sistema',
  'Update existing': 'Aggiornare',
  'Life(When cerated in inventory)': 'La vita (Quando cerated nell\'inventario)',
  'Setup Undercarriage In Inventory': 'Setup Carro In inventario',
  'Model is not selected!': 'Modello non è selezionata!',
  'By changing selection you will lose all your inputs!': 'Cambiando la selezione si perderanno tutti i tuoi ingressi!',
  'Setup new undercarriage': 'Configurazione nuovo carrello',
  'Previous step validation failed!': 'Precedente fase di validazione fallita!',
  'Warning': 'avvertimento',
  'Standard Link or Scallop Resistant Link': 'Collegamento standard o capesante link Resistente',
  'Please select the equipment.': 'Si prega di selezionare l\'attrezzatura.',
  'You can only change the SMU/Hourmeter, LTD and Date of an existing equipment if there have been NO inspections performed, or actions recorded. If you need to record that a component has been changed, you should record an action against that equipment.': 'È possibile modificare solo la SMU / Contaore, LTD e data delle attrezzature esistenti, se non ci sono stati controlli effettuati, o le azioni registrate. Se avete bisogno di registrare che un componente è stato modificato, si dovrebbe registrare un ricorso contro tale apparecchiatura.',
  'Examiner': 'Esaminatore',
  'Reset': 'Reimposta',
  'Evaluation (Worst Side)': 'Evaluation (Worst Side)',
  'A': 'UN',
  'B': 'B',
  'C': 'C',
  'X': 'X',
  'Start Date': 'Data d\'inizio',
  'End Date': 'Data di fine',
  'Single Flange': 'flangia',
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  'Manage Inspection Types': 'Gestisci tipi di ispezione',
  'Left Side': 'Lato sinistro',
  'Language': 'linguaggio',
  'Home Page': 'Pagina',
  'Currency': 'Moneta',
  'Unit of Measurement': 'Unità di misura',
  'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ': 'Determina come le misure sono indicate con voi durante la visualizzazione dei risultati delle ispezioni, e come una percentuale di componenti indossato viene calcolata quando si entra in una misura.',
  'Determines how measurements are displayed to you when viewing inspection results, and how a components percentage worn is calculated when you enter a measurement. ,': 'Determina come le misure sono indicate con voi durante la visualizzazione dei risultati delle ispezioni, e come una percentuale di componenti indossato viene calcolata quando si entra in una misura. ,',
  'Contact': 'Contatto',
  'Full Name': 'Nome e cognome',
  'Phone Number': 'Numero di telefono',
  'Address': 'Indirizzo',
  'Street Address': 'Indirizzo',
  'Suburb / City': 'Periferia / Città',
  'Post Code': 'CAP',
  'State': 'Stato',
  'Country': 'Nazione',
  'Dashboard - Fleet Overview': 'Dashboard - Flotta Panoramica',
  'Millimetres (mm)': 'Millimetri (mm)',
  'Inches (inch)': 'Inches (pollici)',
  'Email Address': 'Indirizzo email',
  'This is the email address that all emails, reports, etc. for your account will be sent to.': 'Questo è l\'indirizzo di posta elettronica che tutte le email, rapporti, ecc per il tuo account verranno inviati.',
  'Username': 'Nome utente',
  'This is what you use to sign in to both the web application and the mobile application.': 'Questo è quello che si usa per accedere a entrambi l\'applicazione web e l\'applicazione mobile.',
  'Change Your Password': 'Cambia la tua password',
  'This is the password you use to sign in to both the web application and the mobile application to perform inspections on.': 'Questa è la password utilizzata per accedere a entrambi l\'applicazione web e l\'applicazione mobile per eseguire le ispezioni su.',
  'New Password': 'nuova password',
  'Repeat New Password': 'Ripetere la nuova password',
  'Update Password': 'Aggiornamento password',
  'Inspections Due Emails': 'Ispezioni email Due',
  'Determines whether the sending of Inspections Due Emails is enabled or disabled. ': 'Determina se l\'invio di ispezioni causa Messaggi di posta elettronica è abilitata o disabilitata.',
  'Flange width is 5.24 in. (133 mm), New tread diameter is 30.16 in. (766 mm)': 'larghezza della flangia è 5,24 in. (133 mm), New diametro battistrada è 30.16 in. (766 mm)',
  'Flange width is 5.21 in. (132.4 mm), New Tread diameter is 29.54 in. (750.2 mm), UT Tool only to determine flange wear only': 'larghezza della flangia è 5,21 a. (132,4 millimetri), diametro nuovo battistrada è 29.54 a. (750,2 millimetri), UT utensile solo per determinare flangia solo indossare',
  'Measure across 3 teeth': 'Misura su 3 denti',
  'Flange diameter is 12.28 in. (312 mm)': 'diametro della flangia è 12.28 in. (312 mm)',
  'ForwardTravelHours': 'ForwardTravelHours',
  'ReverseTravelHours': 'ReverseTravelHours',
  'ForwardTravelKms': 'ForwardTravelKms',
  'ReverseTravelKms': 'ReverseTravelKms',
  'TrackSagLeft': 'TrackSagLeft',
  'TrackSagRight': 'TrackSagRight',
  'DryJointLeft': 'DryJointLeft',
  'DryJointRight': 'DryJointRight',
  'CannonExtLeft': 'CannonExtLeft',
  'CannonExtRight': 'CannonExtRight',
  'ScallopLeft': 'ScallopLeft',
  'ScallopRight': 'ScallopRight',
  'JobsiteNotes': 'JobsiteNotes',
  'InspectionNotes': 'InspectionNotes',
  'Dealer': 'commerciante',
  'Projected': 'proiettata',
  'Difference': 'Differenza',
  'Low': 'Basso',
  'High': 'alto',
  'Medium': 'medio',
  'Additional Observation Lists': 'Liste aggiunta di osservazione',
  'Title': 'Titolo',
  'Image': 'Immagine',
  'Add Observations': 'Aggiungere Osservazioni',
  'Select equipment to create new inspection': 'Selezionare attrezzature per creare nuova ispezione',
  'Cancel': 'Annulla',
  'Start Inspection': 'Inizio ispezione',
  'Please check your user permissions, Only inspector or super user can create inspections': 'Abilita le autorizzazioni degli utenti, Solo ispettore o super-utente può creare le ispezioni',
  'There is no audit history to display.': 'Non v\'è alcuna cronologia di controllo da visualizzare.',
  'Send Report': 'Spedisci il rapporto',
  'Include Quote': 'Includi Citazione',
  'Event Time': 'Orario dell\'evento',
  'Change': 'Modificare',
  'Select Email Recipients': 'Seleziona destinatari e-mail',
  'Send': 'Inviare',
  'Add Recipient': 'Aggiungere il destinatario',
  'An Observation Description is required': 'Un\'osservazione Descrizione è necessario',
  'Adding Observation List': 'Aggiunta Lista di osservazione',
  'Editing Observation List': 'Modifica elenco di osservazione',
  'Save Observation List': 'Salva elenco di osservazione',
  'Name': 'Nome',
  'Background Colour': 'Colore di sfondo',
  'Text Colour': 'Colore testo',
  'Preview': 'Anteprima',
  'Save': 'Salvare',
  'Select System / Component': 'Selezionare Sistema / Component',
  'Action Informations': 'Informazioni azione',
  'Save Action': 'Salva Azione',
  'Multiple Component Replacement': 'Multipla Sostituzione dei componenti',
  'Part Cost': 'Costo parte',
  'Labour Cost': 'Costo del lavoro',
  'MiscCost': 'MiscCost',
  'Note': 'Nota',
  'Current CMU': 'CMU corrente',
  'There is no components on this system, please make sure your undercarriage setup correctly': 'Non ci sono componenti su questo sistema, si prega di assicurarsi che la configurazione del sottocarro correttamente',
  'Setup new System': 'Configurazione nuovo Sistema',
  'Refresh Available Replacement List': 'Aggiornare Lista di ricambio disponibili',
  'There are no available replacements fits this component': 'Non ci sono sostituti, si inserisce questo componente',
  'Select Swap component': 'Seleziona componente Swap',
  'Labour Cost Option': 'Opzione costo del lavoro',
  'Misc Cost': 'Varie Costo',
  'Date of Action': 'Data d\'azione',
  'Times Re-builded / Re-grousered/ Re-sealed': 'Tempi Re-costruito / Re-grousered / Re-sigillato',
  'Total Cost': 'Costo totale',
  'Customer hourly rate': 'tariffa oraria clienti',
  'Uninstall this at SMU/Hourmeter': 'Disinstallare questo a SMU / contaore',
  'Action Against': 'Azione contro la',
  'Action Histories will be affected by this action': 'Storie di azione saranno interessati da questa azione',
  'Disable': 'disattivare',
  'Enable': 'Abilitare',
  'Filter By Serial Number': 'Filtra per numero di serie',
  'CMU (Average)': 'CMU (media)',
  'Part Number': 'Numero di parte',
  'CMU (hrs)': 'CMU (ore)',
  '%Worn': '%Logoro',
  'Action Date': 'Azione Data',
  'Latest Action': 'd\'azione più recenti',
  'Latest Action Date': 'D\'azione più recenti Data',
  'Action Taken': 'Azione intrapresa',
  'Date': 'Data',
  'DATE': 'DATA',
  'History': 'Storia',
  'Relocate System': 'Trasloco sistema',
  'System Notes': 'Note di sistema',
  'Update Notes': 'aggiornamento Note',
  'Relocate To Customer': 'Trasferirsi clienti',
  'Relocate To Jobsite': 'Trasferirsi Cantiere',
  'Eval Overview': 'Classificação Geral',
  'Hours Component Previously Used': 'Componente delle ore usato in precedenza',
  'Please Enter Action Informations': 'Inserisci le informazioni sull\'azione',
  'Red are Required Fields': 'I campi rossi sono obbligatori',
  'SMU/Hourmeter of Equipment at Auction Date': 'SMU / contaore dell\'attrezzatura alla data dell\'asta',
  'Account': 'Account',
  'General': 'Generale',
  'Alerts': 'Avvisi',
  'Dashboard - Component Overview': 'Dashboard - Panoramica dei componenti',
  'Dashboard - Wear Rate Overview': 'Dashboard - tasso di usura Panoramica',
  'Hours': 'Ore',
  'Days': 'Giorni',
  'Weeks': 'Settimane',
  'Months': 'Mesi',
  'Delete': 'Elimina',
  'Currently there is no observation list configured for this equipment': 'Attualmente non esiste una lista di osservazione configurato per questa apparecchiatura',
  'Your Preferences': 'le preferenze',
  'You are currently missing the': 'Stai perdendo il',
  'Add': 'Inserisci',
  'Customer Name': 'Nome del cliente',
  'Right Side': 'Lato destro',
  'Replace with new Chain and all Components': 'Sostituire con una nuova catena e tutti i componenti',
  'Replace with Chain from Inventory': 'Reemplazar con Cadena del inventario',
  'Repairs or Replacements of individual Chain Components': 'Riparazione o sostituzione dei singoli componenti della catena',
  'Replace with New Frame including new components': 'Sostituire con nuovo telaio compreso i nuovi componenti',
  'Replace frame from Inventory': 'Sostituire telaio da libro',
  'Repair or Replace individual Frame components': 'Riparare o sostituire i singoli componenti del telaio',
  'Replace Frame Components in Bulk': 'Sostituire componenti del telaio in Bulk',
  'Which jobsite would you like to move this equipment to?': 'Quale luogo di lavoro ti piacerebbe spostare questa apparecchiatura per?',
  'Update Jobsite': 'Aggiornamento Cantiere',
  'SMU Reading is required': 'SMU Reading è necessaria',
  'New SMU must be greater than previous SMU': 'Nuovo SMU deve essere maggiore di SMU precedente',
  'New BCM must be greater than previous BCM': 'Nuovo BCM deve essere superiore a BCM precedente',
  'New Tonnage must be greater than previous Tonnage': 'Nuovo tonnellaggio deve essere maggiore di Stazza precedente',
  'New SMU': 'Nuovo SMU',
  'Old SMU/Hourmeter': 'Vecchio SMU / Contaore',
  'New SMU/Hourmeter Reading is required': 'Nuovo SMU / contaore Reading è necessaria',
  'Invalid date: Installation date is before equipment setup date!': 'Data non valida: Data di installazione è prima della data di installazione attrezzature!',
  'Equipment Setup Date: ': 'Equipaggiamento data di installazione:',
  'Invalid SMU/HourMeter Reading: SMU/HourMeter at install cannot be less than': 'Invalid SMU / contaore di lettura: SMU / contaore ad installare non può essere inferiore a',
  'Invalid SMU/HourMeter Reading: For the same date SMU/HourMeter has conflict ': 'Invalid SMU / contaore di lettura: Per la stessa data di SMU / contaore ha conflitto ',
  'Invalid SMU/HourMeter: For ': 'Invalid SMU / contaore: Per ',
  ' SMU/HourMeter has conflict ': ' SMU / contaore ha conflitto ',
  'Something is loading please try again after loading completed!': 'Qualcosa sta caricando riprova dopo aver caricato completato!',
  'You haven\'t recorded any repair costs yet.': 'Non hai ancora registrati eventuali spese di ripristino.',
  'Next Inspection Date SMU/Hourmeter': 'Prossima revisione Data SMU / contaore',
  'Next Inspect Date/SMU': 'Prossima revisione Data/SMU',
  'Overview': 'Panoramica',
  'Graph': 'Grafico',
  'Left Side - Component Wear Graph and Forecast': 'Lato sinistro - l\'usura dei componenti Grafico e previsioni',
  'Right Side - Component Wear Graph and Forecast': 'Lato destro - l\'usura dei componenti Grafico e previsioni',
  'Last Inspection Date SMU/Hourmeter': 'Ultima ispezione Data SMU / contaore',
  'New Thermography Inspection': 'Nuova ispezione Termografia',
  'Overall Inspection Comment': 'Ispezione Commento generale',
  'Thermography Inspection': 'Ispezione Termografia',
  'Jan': 'Jan',
  'Feb': 'febbraio',
  'Mar': 'mar',
  'Apr': 'aprile',
  'May': 'Maggio',
  'Jun': 'giugno',
  'Jul': 'luglio',
  'Aug': 'agosto',
  'Sep': 'settembre',
  'Oct': 'ottobre',
  'Nov': 'novembre',
  'Dec': 'dicembre',
  'Items per page': 'oggetti per pagina',
  'Description': 'Descrizione',
  'Currently there is no observation list configured for this inspection and this equipment': 'Attualmente non esiste una lista di osservazione configurato per l\'ispezione e l\'apparecchiatura',
  'Hours remaining until 100% worn': 'Ore rimanenti fino al 100% indossato',
  'There is no audit history to display': 'Non v\'è alcuna cronologia di controllo da visualizzare',
  'Please release this quote report first': 'Si prega di rilasciare questo rapporto citazione prima',
  'Add Job Site': 'Aggiungere cantieri',
  'Return to Undercarriage': 'Torna a Carro',
  'Team Administration ': 'Amministrazione della squadra',
  'A team can be considered either a customer or a dealership. Each team consists of it’s own group of users who have access to equipment within that team': 'Una squadra può essere considerato sia un cliente o una concessionaria. Ogni squadra è composta da un proprio gruppo di utenti che hanno accesso alle apparecchiature all\'interno di quella squadra',
  'Add User': 'Aggiungi utente',
  'Add Customer': 'Aggiungi cliente',
  'Users': 'utenti',
  'Customers': 'I clienti',
  'Dealerships': 'concessionarie',
  'Filter user table': 'tabella utente filtro',
  'Full Name ': 'Nome e cognome',
  'Team': 'Squadra',
  'Access': 'Accesso',
  'More': 'Di Più',
  'Request New Model': 'Richiedi nuovo modello',
  'LTD is the “Life To Date” of the equipment': 'LTD è il “Life A Data” delle apparecchiature',
  'This will generally be the same as the SMU/Hour Meter reading': 'Questo sarà generalmente la stessa della lettura del tester di ora SMU /',
  'If the meter has been changed, LTD shows the actual machine hours where the SMU/Hour Meter will only show the hours since the meter was installed.': 'Se lo strumento è stato modificato, Ltd mostra le ore di macchina effettivi, se il tester di ora SMU / mostrerà solo le ore da quando il contatore è stato installato.',
  'Date of Reading': 'Data di Reading',
  'Undercarriage History ': 'Storia Carro',
  'Select your Equipment ': 'Seleziona il tuo Equipaggiamento',
  'Please Select': 'Selezionare',
  'System S/N': 'System S / N',
  'Life Lived ': 'vita vissuta',
  'Life Remaining (100% Worn': 'Vita residua (100% Worn',
  'Projected Hours ': 'Ore proiettate',
  'Both': 'Tutti e due',
  'Show All Parts': 'Visualizza tutte le parti',
  'No action taken': 'Nessuna azione intrapresa',
  'Never': 'Mai',
  'Sent': 'Inviato',
  'The PDF report has been emailed to all contacts successfully.': 'Il rapporto PDF è stato inviato via email a tutti i contatti con successo.',
  'Failed to send PDF report. System Error Cannot write the document to memory. Invalid Serial Number Version.': 'Impossibile inviare report in formato PDF. Errore di sistema Impossibile scrivere il documento nella memoria. Serial valido numero di versione.',
  'Recommendations included in this quote ': 'Raccomandazioni incluse in questa citazione',
  'Distance Unit': 'Distanza Unità',
  'Kilometers (km)': 'Chilometri (km)',
  'Miles (mi)': 'Miles (mi)',
  'Forward Travel': 'forward Viaggi',
  'Reverse Travel': 'inversione di viaggio',
  'Forward': 'Inoltrare',
  'Reverse': 'Inversione',
  'Create Thermography Inspection': 'Creare Termografia ispezione',
  'Track Sag (mm)': 'Pista Sag (mm)',
  'Pin Number': 'Codice PIN',
  'Therm L/R': 'Therm L / R',
  'Left Side Additional Component': 'Lato sinistro Componente aggiuntivo',
  'No Side Additional Component': 'No laterali supplementari Componente',
  'Right Side Additional Component': 'Lato destro Componente aggiuntivo',
  'You haven\'t set up any equipment yet.': 'Non hai ancora creato alcuna attrezzatura.',
  'You don\'t have any inspection due for the selection.': 'Non si dispone di alcuna causa di ispezione per la selezione.',
  'There are no inspections to display.': 'Non ci sono controlli da mostrare.',
  'General Inspections': 'Generale Ispezioni',
  'Thermography Inspections': 'Termografia Ispezioni',
  'Both Inspections': 'Entrambe le ispezioni',
  'Copy to All': 'Copia a Tutti',
  'Copy to Right': 'Copiare a destra',
  'Done': 'Fatto',
  'Update Equipment': 'Attrezzature Aggiornamento',
  'Undercarriage Inspection': 'Ispezione Carro',
  'Temperature Inspection': 'controllo della temperatura',
  'Severity': 'Severity',
  'Manage Custom Evaluation': 'Gestire valutazione personalizzata',
  'Set Evaluation Ranges': 'Intervalli Set di valutazione',
  'Set Custom Evaluation Ranges': 'Custom valutazione Ranges',
  'Select Level': 'Seleziona livello',
  'Please select individual machine from the search field above.': 'Si prega di selezionare singola macchina dal campo di ricerca qui sopra.',
  'Equipment Level Selected': 'Attrezzature livello selezionato',
  'Select Dealer': 'Select Dealer',
  'Select Jobsite': 'Selezionare Cantiere',
  'A Range': 'A gamma',
  'B Range': 'B Gamma',
  'C Range': 'C Gamma',
  'X Range': 'X Gamma',
  'Track Shoes': 'track Shoes',
  'Track Rollers': 'Rulli pista',
  'Tumblers': 'Bicchieri',
  'Front Idlers': 'fronte Idlers',
  'Rear Idlers': 'Idlers posteriore',
  'Crawler Frame Guide': 'Guida cornice Crawler',
  'A machine with this Serial No and Unit No combination already exists in your Dealer Group. Please contact your Dealer group administrator to be given access to this machine': 'Una macchina con questa combinazione di serie No e No unità esiste già nella tua Gruppo rivenditore. Si prega di contattare l\'amministratore del gruppo di rivenditore per avere accesso a questa macchina',
  'Thermal Images': 'Le immagini termiche',
  'UT Equivalent': 'UT equivalente',
  'Custom Evaluation ranges do not currently apply to Rope Shovels.': 'gamme di valutazione su misura al momento non si applicano alle Pale corda.',
  'Additional Unit Number': 'Numero di unità aggiuntiva',
  'This equipment has 2 or more inspections': 'This equipment has 2 or more inspections',
  'Serial/Unit Search': 'Ricerca seriale/unità',
  'Recalculate & Save': 'Recalculate & Save',
  'No Undercarriage components setup': 'Nessuna configurazione dei componenti del telaio',
  'Enable Tracking by Distance Travelled': 'Abilita il monitoraggio in base alla distanza percorsa',
  'Equipment not in Use': 'Attrezzatura non in uso',
  'Distance': 'Distanza',
  'Propel': 'Spingere',
  'Propel %': 'Spingere %',
  'Average Usage': 'Utilizzo medio',
  'Avg Usage': 'Utilizzo medio',
  'Residual Hours': 'Ore residue',
  'Replacement Date': 'Data di sostituzione',
  'Work Order#': 'Ordine di lavoro n.',
  'Work Order': 'Ordine di lavoro n.',
  'B/Turn%': 'B/Turn%',
  'Res. Life': 'Vita residua',
  'Projected 100%': 'Proiettato al 100%',
  'Projected 120%': 'Proiettato al 120%',
  'Frame Condition': 'Condizioni del telaio',
  'Equipment DOE at Install': 'Distanza dell\'attrezzatura sull\'attrezzatura in fase di installazione',
  'Distance Budget': 'Pianificazione della distanza percorsa',
  'Frame Cost': 'Costo del telaio',
  'Frame Repair Cost': 'Costo di riparazione del telaio',
  'Frame Configuration': 'Configurazione del telaio',
  'Cannon Type': 'Tipo cannone',
  'Residual Life based on 100% budgeted hours/propel hours': 'Vita residua basata sul 100% delle ore di budget/ore di propulsione',
  'Residual Life based on 120% budgeted hours/propel hours': 'Vita residua basata sul 120% delle ore di budget/ore di propulsione',
  'Projected Life based on 100% budgeted hours/propel hours': 'Durata prevista basata sul 100% delle ore preventivate/ore di propulsione',
  'Projected Life based on 120% budgeted hours/propel hours': 'Durata prevista basata sul 120% delle ore preventivate/ore di propulsione',
  'Click to edit condition': 'Fare clic per modificare la condizione',
  'Click to edit': 'Fare clic per modificare',
  'Click to edit Component': 'Fare clic per modificare il componente',
  'UC Inspection': 'Ispezione UC',
  'Maintenance Inspection': 'Ispezione di manutenzione',
  'End of Life Inspection': 'Ispezione di fine vita',
  'Last % Worn Forecasted': 'Ultimo % indossato previsto',
  '% Worn Today': '% indossato oggi',
  'Distance Difference': 'Differenza di distanza',
  '%Worn (heading)': '% indossato (intestazione)',
  'Inspection Type': 'Tipo di ispezione',
  'AVG Daily Usage': 'Utilizzo medio giornaliero',
  'Load More': 'Carica di più',
  'Worn Percentage': '% indossato',
  'Component Hours': 'Componenti ore',
  'Last Insp. % Worn': 'Ultima ispezione % usurata',
  'Display Columns for': 'Mostra colonne per?',
  'Action Type': 'Tipo di azione',
  'Side': 'Lato',
  'Component Type': 'Tipo di Componente',
  'REFRESH': 'AGGIORNARE',
  'L/H Chain CMU': 'Ore accumulate dei componenti del lato sinistro',
  'R/H Chain CMU': 'Ore accumulate dei componenti del lato destro',
  'Action Desc': 'Descrizione dell\'azione',
  'Entered By': 'Inserito da',
  'Entered Date': 'Data inserita',
  'Total': 'Totale',
  'TOTAL': 'Totale',
  'Rolling': 'Rolling',
  'Stock Cost': 'Costo di magazzino',
  'Rolling Stock Cost': 'Costo di magazzino rotolamento',
  'Chain Cost': 'Costo della catena',
  'Segment Cost': 'Costo del segmento',
  'Running Cost': 'Costo di funzionamento',
  'Cost/Hour': 'Costo orario',
  'Cost/Km': 'Costo/Km',
  'Propel Hrs': 'Propel Hrs',
  'Reverse Dist. %': 'Percentuale di inversione percorsa',
  'Total Dist.': 'Distanza totale',
  'Add Recommendation': 'Aggiungi raccomandazione',
  'Save Commment': 'Salva commento',
  'Duplicate Inspection': 'Ispezione duplicata',
  'Refresh linked Inspection': 'Rinfrescare collegato Ispezione',
  'Both Side': 'Entrambi i lati',
  'Forecast': 'Previsione',
  'Edit Component': 'Modifica componente',
  'Add Component': 'Aggiungi componente',
  'Inspection Id': 'ID ispezione',
  'Enter text here...': 'Inserisci testo qui...',
  'Quotes & Recommendations': 'Citazioni e raccomandazioni',
  'Equaliser Bar Type': 'Tipo di barra equalizzatore',
  'Toe Out': 'Toe Out',
  'Straight': 'Dritto',
  'Res. DOC': 'Distanza residua sul componente',
  'Edit Component Type': 'Modifica tipo di componente',
  'Answer': 'Risposta',
  'Hourmeter': 'Contatore di ore',
  'Select Type': 'Seleziona tipo',
  'Select Status': 'Seleziona stato',
  'Include Inventory on Equipment': 'Includi inventario su attrezzature',
  'Include Related Models': 'Includi modelli correlati',
  'Exclude "Scrap"': 'Escludi "rottame"',
  'Task List': 'Elenco delle attività',
  'Chain to Inventory': 'Catena a inventario',
  'Frame to inventory': 'Frame a inventario',
  'Idler to Inventory': 'Idler a inventario',
  'Inventory Report': 'Rapporto di inventario',
  'Serial#': 'Seriale#',
  'Equip unit #': 'Equip unit #',
  'Condition / Hour on Components / Action done': 'Condizione / ora sui componenti / azione fatta',
  '%Link': '% Link',
  'Action': 'Azioni',
  '% Bush': '% Bush',
  'Warning message': 'Messaggio di avvertimento',
  'Images': 'Immagini',
  'Initial cost': 'Costo iniziale',
  'Repair cost': 'Costo di riparazione',
  'Budget': 'Budget',
  'Dist. Budget': 'Budget di distanza',
  'Dist. Budget (Km)': 'Budget di distanza',
  //Translation done by mohit italian
  'Choose a date': 'Scegli una data',
  'Select Asset': 'Seleziona Risorsa',
  'Component Criticality': 'Criticità del Componente',
  'Select Family': 'Seleziona Famiglia',
  'Component List': 'Elenco Componenti',
  '% Contribution to UC Eval': '% Contributo alla Valutazione UC',
  'Fazer': 'Marca',
  'Data de Inspecção': 'Data di Ispezione',
  'No Action': 'Nessuna Azione',
  'Certo': 'Destro',
  'cadeia de série': 'Numero della Catena',
  'série do quadro': 'Numero di Telaio',
  'Frame style': 'Stile del Telaio',
  'arbusto virado': 'Perno e Boccola Ruotati',
  'Unidade#': 'Nº Unità',
  'DG': 'Misuratore di Profondità',
  'R': 'Righello',
  'UK': 'Strumento Sconosciuto',
  'Meter Unit Reading': 'Lettura Contatore Ore',
  'Site de Trabalho': 'Luogo di Lavoro',
  'Measurement Point Description': 'Descrizione del punto di misurazione',
  '% Contribution to Compart': '% Contributo a Compart',
  'Measurement Point List For': 'Elenco dei Punti di Misurazione Per',
  'User Contact': 'Contatto Utente',
  'Contains': 'Contiene',
  'Add New Customer': 'Aggiungi Nuovo Cliente',
  'User Contact Details': 'Dettagli Contatto Utente',
  'Customer Level': 'Livello Cliente',
  'Job Site Level': 'Livello Sito di Lavoro',
  'Equipment Level': 'Livello Attrezzatura',
  'Email': 'Email',
  'Health': 'Stato',
  'Under Carriage': 'Sottocarro',
  'Service': 'Servizio',
  'Please Select a Customer': 'Seleziona un Cliente',
  'Update Selected': 'Aggiorna Selezionati',
  'Delete Selected': 'Elimina Selezionati',
  'Select Customer To Add': 'Seleziona Cliente da Aggiungere',
  'Close': 'Chiudi',
  'Select Job Site(S) To Add': 'Seleziona il/i Sito/i di Lavoro da Aggiungere',
  'Equipments': 'Attrezzature',
  'Select User To Add': 'Seleziona Utente da Aggiungere',
  'Select User(S) To Add': 'Seleziona Utente/i da Aggiungere',
  'Add New User': 'Aggiungi Nuovo Utente',
  'Reload': 'Ricarica',
  'Export All': 'Esporta Tutto',
  'Customer Contact Details': 'Dettagli Contatto Cliente',
  'Customer Contact': 'Contatto Cliente',
  'Inspection Types': 'Tipi di Ispezione',
  'Please select a model first': 'Seleziona prima un modello',
  'An Inspection Name is required': 'È richiesto un nome per l’ispezione',
  'Inspection': 'Ispezione',
  'Manage': 'Gestisci',
  'Inspection Name': 'Nome Ispezione',
  'There is no inspection types configured for ': 'Non ci sono tipi di ispezione configurati per ',
  'Select Additional Observation Level': 'Seleziona Livello di Osservazione Aggiuntiva',
  'Additional Observation Constraint Filter': 'Filtro Vincolo Osservazione Aggiuntiva',
  'Adding Additional Observation List': 'Aggiunta Elenco Osservazioni Aggiuntive',
  'Editing Additional Observation List': 'Modifica Elenco Osservazioni Aggiuntive',
  'Select Answer Type': 'Seleziona Tipo di Risposta',
  'Additional Observation List On Customer': 'Elenco Osservazioni Aggiuntive sul Cliente',
  'Add Dealership': 'Aggiungi Concessionaria',
  'Add Dealer Group': 'Aggiungi Gruppo Concessionari',
  'Job Sites': 'Siti di Lavoro',
  'Dealer Group': 'Gruppo Concessionari',
  'Undercarriage Inspections Due Emails': 'Email per ispezioni del sottocarro in scadenza',
  'Daily Inspections Due Emails': 'Email di avviso per ispezioni giornaliere',
  'Alerting a user of any overdue Digital Inspections which have not been completed after 40 hours. ': 'Avvisa l’utente di eventuali ispezioni digitali scadute che non sono state completate dopo 40 ore. ',
  'PIP Emails': 'Email PIP',
  'Receive email alerts for PIP’s  ': 'Ricevi avvisi email per i PIP ',
  'DFI Emails': 'Email DFI',
  'Receive email alerts for DFI’s  ': 'Ricevi avvisi email per i DFI ',
  'Leave Approval Emails': 'Email di approvazione ferie',
  'NSW': 'NSW',
  'WA': 'WA',
  'Alerts on the Dashboards': 'Avvisi nelle Dashboard',
  'When the box is ticked the alerts will show. ': 'Quando la casella è selezionata, gli avvisi verranno mostrati. ',
  'User Preferences': 'Preferenze Utente',
  'Undercarriage User Type': 'Tipo Utente Sottocarro',
  'UC Dashboard Settings': 'Impostazioni Dashboard UC',
  'UC Component Inspection Order': 'Ordine Ispezione Componenti UC',
  'UC Multiple Measurements': 'Misurazioni Multiple UC',
  'UC Equipment Conditions': 'Condizioni Attrezzatura UC',
  'UC Inspection & Jobsite Comments Display': 'Visualizzazione Commenti Ispezione UC e Sito di Lavoro',
  'Undercarriage Forecast - % Worn Today': 'Previsione Sottocarro - % Usura Oggi',
  'GET Dashboard Tasks Show/Hide': 'Mostra/Nascondi Attività Dashboard GET',
  'Enable Replace Existing tab': 'Abilita scheda Sostituisci esistente',
  'UC Equipment Detail Settings': 'Paramètres des Détails de l’Équipement UC',
  'Please refresh the page to see this change': 'Aggiorna la pagina per vedere questa modifica',
  //
  //Aditya
  'Distance Ratio': 'Rapporto di distanza',
  'Preset Forecast Wear Rates': 'Tassi di Usura Preimpostati per la Previsione',
  'Forecast Selection': 'Selezione Previsione',
  'Usage (Hrs)': 'Utilizzo (Ore)',
  'Latest SMU/DOE': 'Ultimo SMU/DOE',
  'Average From Last 3 Inspections': 'Media delle ultime 3 ispezioni',
  'Show dates for 100% Worn': 'Mostra le date per usura al 100%',
  'Preset Averages': 'Medie Preimpostate',
  'Safety Factor': 'Fattore di Sicurezza',
  'SMU:': 'SMU:',
  'Show dates for 120% Worn': 'Mostra le date per usura al 120%',
  'Winter': 'Inverno',
  'Summer': 'Estate',
  'Shoulder': 'Spalla',
  'Other': 'Altro',
  'Model Level': 'Livello Modello',
  'Machine Level': 'Livello Macchina',
  'Last 4th Historical Inspection': '4ª Ultima Ispezione Storica',
  'DOE:': 'DOE:',
  'Forecast-Settings': 'Previsioni-Impostazioni',
  'Forecast Method': 'Metodo di previsione',
  'Forecast Future Service': 'Previsioni di Servizio Futuro',
  'Next PM Service': 'Prossimo Servizio di Manutenzione',
  '2nd PM Service': '2º Servizio di Manutenzione',
  'Floating Date': 'Data Fluttuante',
  'Floating Date 2': 'Data Fluttuante 2',
  'None': 'Nessuno',
  'Latest SMU': 'Ultimo SMU',
  'Save/Refresh': 'Salva/Aggiorna',
  'Prior Inspect 3': 'Ispezione precedente 3',
  'Prior Inspect 1': 'Ispezione precedente 1',
  'Prior Inspect 2': 'Ispezione precedente 2',
  'Last Inspect': 'Ultima ispezione',
  'Avg CMU': 'CMU medio',
  'Per % Wear': 'Per % usura',
  'Avg DOC': 'DOC medio',
  'Date 100% Worn': 'Data 100% usurato',
  'Date 120% Worn': 'Data 120% usurato',
  'Last Inspection': 'Ultima Ispezione',
  'Show Last 4th Historical Inspection': 'Mostra la 4ª Ultima Ispezione Storica',
  'Planner': 'Pianificatore',
  //
  'Fleet Reporting': 'Report della flotta',
  'Pre and Post Hire Report': 'Report di evoluzione pre e post installazione',
  'Email Log': 'Registro e‑mail',
  'Advances Forecasting': 'Previsioni avanzate',
  'Inspection Data Export': 'Esportazione dati di ispezione',
  'Report Selection': 'Seleziona report',
  'Inspected machines': 'Macchine ispezionate',
  'Identified Issues': 'Problemi identificati',
  'Track Tensions': 'Tensione del cingolo',
  'Undercarriage Configuration': 'Configurazione del carro',
  'Dealer Name': 'Nome del concessionario',
  'Filter by Component Details': 'Filtra per dettagli del componente',
  'Jobsite Type': 'Tipo di sito di lavoro',
  'Only components currently fitted to equipment': 'Solo i componenti attualmente installati sull’attrezzatura.',
  'Export to Excel': 'Esporta in Excel',
  'Component Performance Details': 'Dettagli delle prestazioni del componente',
  'Averages': 'Medie',
  'Part': 'Pezzo',
  'Last Worn': 'Ultima usura',
  'Last Eval': 'Ultima valutazione',
  'Projected 100% Hrs': 'Ore previste al 100%',
  'Projected 120% Hrs': 'Ore previste al 120%',
  'Date Removed': 'Data di rimozione',
  'Cost Per Hour': 'Costo per ora',
  'AVG': 'Media',
  'Start date': 'Data di inizio',
  'Interval': 'Intervallo',
  'Serial No./ Unit No.': 'N° di serie / N° unità',
  'Totals Only': 'Solo totali',
  'Totals & Details': 'Totali e dettagli',
  'OEM Part#': 'Codice parte OEM',
  'MFR Part#': 'Codice parte produttore',
  'Select equipment': 'Seleziona attrezzatura',
  'Meter reading': 'Lettura ore',
  'Life to Date': 'Ore totali accumulate',
  'Setup date': 'Data di configurazione',
  'Download report': 'Scarica report',
  'Add Inspection and Comments': 'Aggiungi ispezione e commenti',
  'log sent': 'Registro inviato',
  'Report Number': 'Numero del report',
  'Perform Search': 'Cerca',
  'Report No': 'N° report',
  'Log Date': 'Data del registro',
  'Sent to Address': 'Inviato a',
  'Selection Criteria for Filtering': 'Criteri di selezione per il filtro',
  'Select Brand': 'Seleziona marca',
  'Select Year': 'Seleziona anno',
  'Select Month': 'Seleziona mese',
  'Show and hide columns': 'Mostra e nascondi colonne',
  'Saved Scenarios for Forecasting': 'Scenari salvati per le previsioni',
  'Segments': 'Segmenti della ruota motrice',
  'Averages for selected data': 'Medie dei dati selezionati',
  'Scenario': 'Scenario',
  'Update selection': 'Aggiorna selezione',
  'export': 'Esporta',
  'Machine Inspection Data': 'Dati di ispezione della macchina',
  'Average Daily Hrs': 'Ore medie giornaliere',
  'Average Daily Dist': 'Distanza media giornaliera',
  'Inspection Events': 'Eventi di ispezione',
  'Risk Rating': 'Valutazione del rischio',
  'Inspection Comments': 'Commenti dell’ispezione',
  'Recommended Actions': 'Azioni raccomandate',
  'Your Inspection ID': 'ID dell’ispezione',
  'Measured Data Part Wear % per Component': 'Usura (%) misurata per componente',
  'Bush Turned Left': 'Boccola ruotata a sinistra',
  'Bush Turned Right': 'Boccola ruotata a destra',
  'Additional unit number': 'Numero unità aggiuntivo',
  'BCM at setup': 'BCM alla configurazione',
  'Tonnage at setup': 'Tonnellaggio alla configurazione',
  'Choose file': 'Scegli file',
  'No file chosen': 'Nessun file selezionato',
  'Usage Distance (km) per day': 'Distanza di utilizzo (km) al giorno',
  'How often will you be inspecting this equipment?': 'Con quale frequenza ispezionerai questa attrezzatura?',
  'You can also set some additional details': 'Puoi aggiungere ulteriori dettagli, anche se non è obbligatorio.',
  'Date at install (chain)': 'Data di installazione (catena)',
  'SMU on Equipment at Install': 'Ore SMU all’installazione',
  'Historical Hours on Chain at Install': 'Ore storiche sulla catena dall’installazione',
  'Date at Install (Frame)': 'Data di installazione (telaio)',
  'Budget life(Hrs)': 'Vita pianificata (ore)',
  'Budget Distance(Km)': 'Distanza pianificata (km)',
  'Historical Hours on Frame at Install': 'Ore storiche sul telaio dall’installazione',
  'Date of Setup': 'Data di configurazione',
  'Historical Hours on Chain at Setup': 'Ore storiche della catena alla configurazione',
  'Historical Distance on Chain at Setup': 'Distanza storica della catena alla configurazione',
  'Chain Components': 'Componenti della catena',
  'Show Parts Ids': 'Mostra codici parti',
  'Job': 'Lavoro',
  'Cleaner Holes': 'Fori di pulizia',
  'UnKnown': 'Sconosciuto',
  'Disabled': 'Disabilitato',
  'Edit Observation': 'Modifica osservazione',
  'Update Equipment Status': 'Aggiorna stato dell’attrezzatura',
  'Select Equipment Status': 'Seleziona stato dell’attrezzatura',
  'Update': 'Aggiorna',
  'Search WSRE': 'Cerca officina di riparazione',
  'Job Status': 'Stato del lavoro',
  'Temperature Inspections': 'Ispezione temperatura',
  'CRACK VIEW': 'Vista delle crepe',
  'Search Results': 'Risultati della ricerca',
  '# of Cracks': 'Numero di crepe',
  'Total Crack Length': 'Lunghezza totale crepe',
  'Average Crack Length': 'Lunghezza media crepe',
  'Fixed': 'Riparato',
  'Hide Favorites': 'Nascondi preferiti',
  'Create Favorite': 'Crea preferito',
  'Select family': 'Seleziona famiglia',
  'Select asset Make': 'Seleziona marca dell’asset',
  'Select Job site': 'Seleziona sito di lavoro',
  'Select Male': 'Seleziona marca',
  'Select Component Type': 'Seleziona tipo di componente',
  'Select Asset Type': 'Seleziona tipo di asset',
  'Asset Serial Number': 'Numero di serie asset',
  'Select Asset Definition': 'Seleziona definizione asset',
  'Select Serial Number': 'Seleziona numero di serie',
  'Select Alt. Number': 'Seleziona numero alternativo',
  'Template': 'Modello',
  'All': 'Tutto',
  'Rest': 'Pulisci',
  'Serch': 'Cerca',
  'Asset View': 'Vista asset',
  'Asset Location History': 'Storico posizione asset',
  'Crack View': 'Vista crepe',
  'Asset definition': 'Definizione asset',
  'Alt. Serial': 'N° seriale alternativo',
  'Imp. Serial': 'N° seriale imp.',
  'Life': 'Vita',
  'Residual': 'Residuo',
  'Total Life': 'Vita totale',
  'Replace Date': 'Data sostituzione',
  'Warranty Status': 'Stato garanzia',
  'Build No': 'Numero costruzione',
  'Next Inspect': 'Prossima ispezione',
  'Flag': 'Etichetta',
  'Please select the customer and job site': 'Seleziona cliente e sito di lavoro',
  'What is the earliest known SMU': 'Qual è la SMU più vecchia conosciuta?',
  'BCM at Setup': 'BCM alla configurazione',
  'Tonnage at Setup': 'Tonnellaggio alla configurazione',
  'Tons': 'Tonnellate',
  'Choose files': 'Scegli file',
  'No Files Chosen': 'Nessun file scelto',
  'Hours of Use': 'Ore di utilizzo',
  'Per Day': 'Al giorno',
  'Tues': 'Mar',
  'Thurs': 'Gio',
  'Advanced Forecasting': 'Previsioni avanzate',
  'Now that you have setup your equipment': 'Ora che hai configurato l’attrezzatura, devi configurare gli implementi prima di registrare le ispezioni.',
  'Setup Implements for This Equipment': 'Configura implementi per questa attrezzatura',
  'New Implement': 'Nuovo implemento',
  'Customer and Jobsite Selection': 'Selezione cliente e sito',
  'Add to Equipment': 'Aggiungi all’attrezzatura',
  'Jobsite Inventory': 'Inventario del sito',
  'Equipment SMU at initial Install': 'SMU dell’attrezzatura all’installazione iniziale',
  'Implement Definition': 'Definizione implemento',
  'Select Asset Model': 'Seleziona modello asset',
  'Implement Capacity': 'Capacità implemento',
  'Select GET Type': 'Seleziona tipo GET',
  'Implement Details': 'Dettagli implemento',
  'Implement Serial Number': 'Numero di serie implemento',
  'Additional Serial #': 'Numero di serie aggiuntivo',
  'Implement make': 'Marca implemento',
  'Implement Budget': 'Budget implemento',
  'Implement Tons at setup': 'Tonnellaggio implemento alla configurazione',
  'Implement Setup Date and Hours': 'Data e ore configurazione implemento',
  'Hours on Implement at setup': 'Ore sull’implemento alla configurazione',
  'Implement Cost': 'Costo implemento',
  'Implement Purchased Cost': 'Costo di acquisto implemento',
  'Save changes & Go To next': 'Salva modifiche e continua',
  'Add implement Image': 'Aggiungi immagine implemento',
  'Advanced Implement Copying': 'Copia avanzata implementi',
  'Source Details': 'Dettagli origine',
  'Please select the customer and job site where the EXISTING implement is located': 'Seleziona cliente e sito dove si trova l’implemento ESISTENTE',
  'Is the EXISTING implement on an equipment, or in inventory ?': 'L’implemento esistente è su un’attrezzatura o in inventario?',
  'Destination Details': 'Dettagli destinazione',
  'Please select the customer and job site where the DESTINATION implement is located': 'Seleziona cliente e sito dove sarà l’implemento DESTINAZIONE',
  'Is the DESTINATION implement on an equipment, in inventory or exisiting implement?': 'L’implemento destinazione è su attrezzatura, in inventario o già esistente?',
  'Select Implement(s) to be copied': 'Seleziona implementi da copiare',
  'Select Implement': 'Seleziona implemento',
  'Imp Type:Serial': 'Tipo imp.: Serie',
  'Implement Type': 'Tipo implemento',
  'New Serial No.': 'Nuovo numero di serie',
  'Equipment SMU at Setup': 'SMU attrezzatura alla configurazione',
  'Budget Hours': 'Ore pianificate',
  'Purchased Cost': 'Costo d’acquisto',
  'Copied': 'Copiato',
  'Copy Selected': 'Copia selezionati',
  'Modify Asset': 'Modifica asset',
  'Add Implement Image': 'Aggiungi immagine implemento',
  'Asset Definition Setup': 'Configurazione definizione asset',
  'Input Asset Definition': 'Inserisci definizione asset',
  'Input Model #': 'Inserisci modello #',
  // 'Reset': 'Pulisci',
  // 'Add New': 'Aggiungi nuovo',
  'Asset/System Type': 'Tipo asset/sistema',
  'Asset Definition': 'Definizione asset',
  'Model #': 'N° modello',
  'PDF Formats to be used': 'Formati PDF da utilizzare',
  'Manage Observation Lists': 'Gestisci liste osservazioni',
  'Select a Customer': 'Seleziona un cliente',

  'Serial/ Unit Search': 'Ricerca per N° serie/unità',
  'Stautus': 'Stato',
  'Off-Highway': 'Fuoristrada',
  'Tempreture Inspections': 'Ispezione temperatura',
  'UC planner': 'Pianificatore del carro',
  'Display options': 'Opzioni di visualizzazione',
  'Coloums': 'Colonne',
  'Dates': 'Date',
  'Legend': 'Legenda',
  'tasks': 'Compiti',
  'Enter SMU/dates': 'Inserisci SMU/Data',
  'Create favorite Generate': 'Crea preferito / Genera',
  'February': 'Febbraio',
  'Enter Date for SMU': 'Inserisci data per SMU',
  'Favorite': 'Preferito',
  'Last Known': 'Ultima lettura SMU o distanza nota',
  'Enter Date': 'Inserisci data',
  'Enter SMU': 'Inserisci SMU',
  'Equipment Serial No/Unit No': 'Numero di serie/unità dell’attrezzatura',
  'Select All': 'Seleziona tutto',
  'Recommended Action': 'Azione raccomandata',
  'Oldest Date': 'Data più vecchia',
  'Highest Severity': 'Massima gravità',
  'Earliest': 'Lettura SMU più vecchia',
  'Hours Gained': 'Ore guadagnate dopo azione',
  'Adjust all staus for equipment': 'Regolare tutti gli stati dell’attrezzatura',
  'Adjust all status for Equip': 'Regolare tutti gli stati dell’attrezzatura',
  'Action Search': 'Ricerca Azione',
  'Favorites': 'Preferiti', 'Download': 'Scarica',
  'Preparing Planner': 'Preparazione Pianificatore',
  'Generate': 'Genera',
  'SMU & PMU Service': 'Servizio SMU & PMU',
  'No data available': 'Nessun dato disponibile',
  'The data will be cleared, are you sure': 'I dati verranno cancellati, sei sicuro?',
  'Search O/S UC Action Recommendations': 'Cerca Raccomandazioni di Azione O/S UC',
  'Equipment Serial No/UnitNo': 'N. di Serie Attrezzatura/N. Unità',
  'Action Recommendation date is a future Date, which is not permissible in the Action Taken Screen, the system will use the current Date and Hour meter, please adjust accordingly': 'La data della raccomandazione dell’azione è una data futura, il che non è consentito nella schermata Azione Eseguita. Il sistema utilizzerà la data corrente e il contatore delle ore, si prega di regolare di conseguenza.',
  'Continue': 'Continua',
  'Summary': 'Riepilogo',
  'Hide Favourites': 'Nascondi Preferiti',
  'Please use the Search field above to select what equipment you are shown.': 'Si prega di utilizzare il campo di ricerca sopra per selezionare quale attrezzatura visualizzare.',
  'Asset Alt. Number': 'Numero Alternativo Asset',
  'EQUIPMENT VIEW': 'VISTA ATTREZZATURA',
  'ASSET VIEW': 'VISTA RISORSA',
  'ASSET LOCATION HISTORY': 'STORICO POSIZIONE RISORSA',
  'Select Side': 'Seleziona lato',
  'Select Unit Number': 'Seleziona numero di unità',
  'Unit No': 'N° unità',
  'Average Projected to 100%': 'Media proiettata al 100%',
  'Average Projected to 120%': 'Media proiettata al 120%',
  'Average Cost per Hour': 'Costo medio per ora',

  'Usage Distance': 'Distanza di utilizzo',
  'per day': 'al giorno',

  "SMU Last Known Date": "Data dell'Ultima SMU Conosciuta",
  "SMU Last Known SMU": "Ultima SMU Conosciuta",
  "Distance Forward": "Distanza in Avanti",
  "Distance Reverse": "Distanza all'Indietro",
  "Last Dist. Total": "Ultima Distanza Totale",
  "Last Known Dist. Date": "Data dell'Ultima Distanza Conosciuta",
  "Forward Distance": "Distanza in Avanti",
  "Reverse Distance": "Distanza all'Indietro",
  "Total Distance": "Distanza Totale",
  "Close PM's": "Chiudi PM",
  "Next Pm Service": "Prossimo Servizio PM",
  "2nd Pm Service": "Secondo Servizio PM",
  "Floating Date 1": "Data Mobile 1",

  "Tools & Actions": "Strumenti e Azioni",
  "Display Options": "Opzioni di Visualizzazione",
  "Enter SMU/Dates": "Inserisci SMU/Date",
  "Last Inspect. Worn %": "% Usura dell’Ultima Ispezione",
  "% Worn <br>Today": "% Usura <br>Oggi",
  "Floating Pm1 Service": "Servizio PM Fluttuante 1",
  "Floating Pm2 Service": "Servizio PM Fluttuante 2",
  "100 % Worn": "100 % Usurato",
  "120 % Worn": "120 % Usurato",


  "Start Time": "Ora di Inizio",
  "Log Sent": "Registro Inviato",
  "Not Sent": "Non Inviato",
  "Lab Number": "Numero di Laboratorio",
  "Sent To Address": "Inviato All'Indirizzo",
  "Please use the Search field above to select what Email Log you are shown.":
    "Utilizzare il campo di ricerca sopra per selezionare quale registro email visualizzare.",
  "Next Pm Service Header": "Prossimo \nServizio PM",
  "2nd Pm Service Header": "Secondo \nServizio PM",
  "Floating Pm1 Service Header": "Servizio PM\n Fluttuante 1",
  "Floating Pm2 Service Header": "Servizio PM \nFluttuante 2",
  "100 % Worn Header": "100 % \nUsurato",
  "120 % Worn Header": "120 % \nUsurato",
  "Last Inspect. Worn % Header": "% Usura \ndell’Ultima\n Ispezione",

  'Last Known Dist. Date Header':"Data dell’Ultima \nDistanza Conosciuta",
    'SMU Last Known Date Header':'Data dell’Ultima\n SMU Conosciuta',
    'SMU Last Known SMU Header':'Ultimo \nSMU Conosciuto',
    'Distance Forward Header':'Distanza in\n Avanti',
    'Distance Reverse Header':'Distanza in\n Retromarcia',
    'Last Dist. Total Header':'Totale \nUltima Distanza',
    'Forward Distance Header':'Distanza in\n Avanti',
    'Reverse Distance Header':'Distanza in\n Retromarcia',
    'UNDERCARRIAGE': 'SOTTOCARRO',
    'Alert Name': 'Nome Avviso',
'Frequency': 'Frequenza', 
'Enabled': 'Abilitato',
'Email Enabled': 'Email Abilitato',
'Percentage Worn': 'Percentuale di Usura',
"Planning": "Pianificazione",
  "Setup": "Configurazione",
  "Part Search": "Ricerca Parti",
   "Digital Inspections": "Ispezioni Digitali",
  "Field Inspection Dashboard": "Dashboard Ispezioni sul Campo",
  "Get & Wear Surfaces": "GET e Superfici di Usura",
  "GET Inspections": "Ispezioni GET",
  "New GET Inspection": "Nuova Ispezione GET",
  "Find Inspections": "Trova Ispezioni",
  "Asset Model Setup": "Configurazione Modello Asset",
  "Document Library": "Libreria Documenti",
  "PIP Setup": "Configurazione PIP",
  "Warranty Tracking": "Monitoraggio Garanzia",
  "Observation List Setup": "Configurazione Lista Osservazioni",
  "CRC Dashboard": "Dashboard CRC",
  "Undercarriage": "Sottocarro",
  "Setup Additional Components": "Configurare Componenti Aggiuntivi",
  "Safety": "Sicurezza",
  "Dashboards": "Dashboard",
  "Inductions": "Induzioni",
  "Other Inspections": "Altre Ispezioni",
  "Policies and Procedures": "Politiche e Procedure",
  "Leave": "Permesso",
  "HOME - Admin Access": "HOME - Accesso Admin",
  "Safety Dashboard": "Dashboard Sicurezza",
  "General Dashboard": "Dashboard Generale",
  "Safety Indicators": "Indicatori di Sicurezza",
  "- View/Edit Monthly Hours": "Visualizza/Modifica Ore Mensili",
  "- Add Monthly Dashboard Message": "Aggiungi Messaggio Mensile alla Dashboard",
  "- Add Toolbox Talk": "Aggiungi Toolbox Talk",
  "- Add Take 5s": "Aggiungi Take 5",
  "- Setup Forms": "Configura Moduli",
  "Upload Completed Paper Form": "Carica Modulo Cartaceo Completato",
  "Training Register": "Registro Formazione",
  "Search & Review Forms": "Cerca e Rivedi Moduli",
  "Select Form": "Seleziona Modulo",
  "Enter Safety Observation": "Inserisci Osservazione di Sicurezza",
  "Search Safety Observations": "Cerca Osservazioni di Sicurezza",
  "- Setup Departments/Work Areas": "Configura Dipartimenti/Aree di Lavoro",
  "- Setup Users": "Configura Utenti",
  "- Setup Incident Types": "Configura Tipi di Incidente",
  "- Setup Safety Questions": "Configura Domande di Sicurezza",
  "Perform Induction": "Esegui Induzione",
  "Search Induction": "Cerca Induzione",
  "- Setup Induction Types & Sections": "Configura Tipi e Sezioni di Induzione",
  "- Setup Induction Slides": "Configura Slide di Induzione",
  "- Setup Induction Questions": "Configura Domande di Induzione",
  "Leave Admin": "Amministrazione Permessi",
  'GET Dashboard': 'Dashboard GET',
  'TTadmin': 'Amministratore TT',
  "Action Description & Comment": "Descrizione Azione e Commento",
  "Old Value": "Valore Precedente",
  "New Value": "Nuovo Valore",
  "Modified By": "Modificato Da",
  "Audit Trail": "Registro di Controllo",
  "Screen": "Schermata",
  'Copy Implement Advanced': 'Copia Implementa Avanzato',
  'Cast': 'Cast',
  'Unit #': 'Unità n. #',
  "Number of Observations": "Numero di Osservazioni",
  "Components Currently Using": "Componenti Attualmente in Uso",
  "Crack Obs. List": "Elenco delle Osservazioni sulle Crepe",
  "Crack Severity List": "Elenco della Gravità delle Crepe",
  "Active": "Attivo",
  "Setup New List": "Configura Nuova Lista",
  "List Name": "Nome della Lista",
  "General Bucket Observations": "Osservazioni Generali della Benna",
  "Add Observation": "Aggiungi Osservazione",
  "Enter Observation and Press Add": "Inserisci l'Osservazione e Premi Aggiungi",
  "Observation List": "Elenco delle Osservazioni",
  "Edit Observation List": "Modifica Elenco Osservazioni",
  "Add/Update": "Aggiungi/Aggiorna",
  "Observaton": "Osservazione",
  "There are no observation lists created for this customer. Click Add New to create one.": "Non ci sono elenchi di osservazioni creati per questo cliente. Fai clic su Aggiungi Nuovo per crearne uno.",
  "Existing Implement": "Implemento Esistente",
  "Implement": "Implemento",
  "Selecting Copying of Schematics for Asset": "Selezione della Copia degli Schemi per l’Asset",
  "Reference Schematics to Originating Templates": "Riferire gli Schemi ai Modelli Originali",
  "Specific Assets": "Asset Specifici",
  "The Source Implement is not listed as fitting the Model of the Equipment you have selected,": "L’implemento sorgente non è elencato come compatibile con il modello dell’attrezzatura selezionata,",
  "however if you wish to proceed it will be added.": "tuttavia se desideri procedere verrà aggiunto.",
  "Implement Hours at Setup": "Ore Implemento all’Installazione",
  "Implement Serial": "Seriale Implemento",
  "Select Component": "Seleziona Componente",
  "Component Name": "Nome Componente",
  "Part No": "Nº Parte",
  "Select Obs. Point": "Seleziona Punto di Osservazione",
  "Observation Point": "Punto di Osservazione",
  "OP Type": "Tipo OP",
  "Update Image": "Aggiorna Immagine",
  "Delete Image": "Elimina Immagine",
  "Fabricated": "Fabbricato",
  "Meter Read / SMU": "Lettura del Contatore / SMU",
  "JSON": "JSON",
  "CSV Export": "Esporta CSV",
  "No Data Found - please can reset your selection and try again.": "Nessun dato trovato - ripristina la selezione e riprova.",
  "Start SMU": "SMU Iniziale",
  "End SMU": "SMU Finale",
  "Start CMU": "CMU Iniziale",
  "End CMU": "CMU Finale",
  "Start Dist": "Distanza Iniziale",
  "End Dist": "Distanza Finale",
  "Update Selection": "Aggiorna selezione",
  "On-Hire Inspection": "Ispezione di Ingresso",
  "Off-Hire Inspection": "Ispezione di Uscita",
  "Left % Used": "% Usato Sinistra",
  "Right % used": "% Usato Destra",
  "Original Cost": "Costo Originale",
  "Leave a comment": "Lascia un commento",
  "GET Inspection": "Ispezione GET",
  "Get Implement": "Ottieni Implemento",
  "Digital Forms": "Moduli Digitali",
  "Equipment SMU at Initial Install": "SMU Attrezzatura all’Installazione Iniziale",
  "Implement Make": "Marca Implemento",
  "Budget at Setup": "Budget alla Configurazione",
  "Implement Tons at Setup": "Tonnellate Implemento alla Configurazione",
  "Hours on Implement at Setup": "Ore Implemento alla Configurazione",
  "Skip Changes & Go To Next": "Salta Modifiche e Vai al Successivo",
  "Save Changes & Go To Next": "Salva Modifiche e Vai al Successivo",
  'System Calculated Usage': 'Utilizzo Calcolato dal Sistema',
  'Manually Entered Usage': 'Utilizzo Inserito Manualmente',
  'Eqiup Unit#': 'N° Unità Attrezzatura',
  "Please select an Implement to inspect first!": "Seleziona prima un implemento da ispezionare!",
  "Equipment Smu at Install": "SMU dell'attrezzatura all'installazione",
  "Equipment SMU at Inspection": "SMU dell'attrezzatura all'ispezione",
  "Include Cover Page on report": "Includi la copertina nel report",
  "Include Overall Comment on Report": "Includi il commento generale nel report",
  "Work Required": "Lavoro richiesto",
  "Job File #": "Numero file lavoro #",
  "Repair Request #": "Numero richiesta di riparazione #",
  "Select Schematic to add an observation point/Crack (Click on thumbnail)": "Seleziona uno schema per aggiungere un punto di osservazione/crepa (clicca sulla miniatura)",
  "Part#": "Numero parte #",
  "Wear Limit": "Limite di usura",
  "Question": "Domanda",
  "Instructions": "Istruzioni",
  "Location Name": "Nome posizione",
  "Obs. List": "Lista oss.",
  "Severity List": "Lista severità",
  "Incl. Rep.": "Incl. nel rep.",
  "Refresh with Asset Type Report Options": "Aggiorna con le opzioni di report per tipo di asset",
  "ReCalculate Inspection": "Ricalcola ispezione",
  "Inspection Images": "Immagini di ispezione",
  "Observation Point View": "Vista del punto di osservazione",
  "Area Inspected": "Area ispezionata",
  "Eng. Evaluation": "Valutazione ingegneristica",
  "Addressed To": "Indirizzato a",
  "Location": "Posizione",
  "Component Type comment for Report": "Commento del tipo di componente per il report",
  "Report Configuration": "Configurazione del report",
  "Pre-Inspection Checklist": "Checklist pre-ispezione",
  "Tray Report Configuration": "Configurazione del report del vassoio",
   "Save Report Configuration At Asset Type": "Salva configurazione report per tipo di asset",
  "Alternate Group Name": "Nome alternativo del gruppo",
  "Include in Report Summary": "Includi nel riepilogo del report",
  "Include Graph in Summary": "Includi grafico nel riepilogo",
  "Summary Eval": "Valutazione riepilogo",
  "Include Schematic in Summary": "Includi schema nel riepilogo",
  "Image Rotation": "Rotazione immagine",
  "Summary Comment": "Commento riepilogo",
  "Enter a Summary Comment.": "Inserisci un commento di riepilogo",
  "Include in Report Body": "Includi nel corpo del report",
  "Include Data Table": "Includi tabella dati",
  "Include Graph": "Includi grafico",
  "Pie Chart": "Grafico a torta",
  "Speedometer Chart": "Grafico tachimetro",
  'Undercarriage Rebuild Centre': 'Centro di revisione sottocarri',
  "Start New Undercarriage Rebuild Center": "Avvia Nuovo Centro di Ricostruzione del Sottocarro",
  "Find Undercarriage Rebuild Centre": "Trova Centro di Ricostruzione del Sottocarro",
  "Frame Undercarriage Rebuild Centre": "Centro di Ricostruzione del Sottocarro (Telaio)",
  "Chain Undercarriage Rebuild Centre": "Centro di Ricostruzione del Sottocarro (Catena)",
  "Alerts (Current)": 'Avvisi (Attuali)',
  "Source": 'Fonte',
  "Move to History": 'Sposta nella cronologia',
  "Alert History": 'Cronologia avvisi',
  "Move to Current": 'Sposta agli attuali',
  'Selection': 'Selezione',
  'Pass/Fail': 'Superato/Non superato',
  'Yes/No': 'Sì/No',
  'Reading No.': 'Lettura N.',
  'Accepted': 'Accettato',
  'Monitor': 'Monitorare',
  'Not Accepted': 'Non accettato',
  'Pass': 'Superato',
  'Fail': 'Non superato',
  "NA": "N/D",
  "NO": "No",
  "YES": "Sì",
  "Enter Equipment Summary Notes...": "Inserisci note riepilogative dell'attrezzatura...",
  "Created On": "Creato il",
  "Summary Notes": "Note riepilogative",
  "Last Modified On": "Ultima modifica il",
  "Last Modified By": "Ultima modifica da",
  "Edit Summary Notes": "Modifica note riepilogative",
  "Equipment Summary Notes": "Note riepilogative dell'attrezzatura",
  "DNET Cost": "Costo DNET",
  "Search Result": "Risultato Ricerca",
  "Request New Chain": "Richiedi Nuova Catena",
  "Chain Des": "Descrizione Catena",
  "Serial Number Start": "Numero di Serie Iniziale",
  "Serial Number End": "Numero di Serie Finale",
  "Pitch": "Passo",
  "# Of Links": "N° Maglie",
  "Part Required": "Parte Richiesta",
  "Component Description": "Descrizione Componente",
  "PartLine": "Linea Parte",
  "Quantity Required": "Quantità Richiesta",
  "Quantity in Stock": "Quantità in Magazzino",
  "DNET  Cost Each": "Costo Unitario DNET",
  "DNET  Cost Total": "Costo Totale DNET",
  "Add to Part List": "Aggiungi alla Lista Parti",
  "Request Part List": "Richiedi Lista Parti",
  "Comments": "Commenti",
  "Parts": "Parti",
  "Send Email": "Invia Email",
  "Summary Notes History": "Cronologia delle Note di Riepilogo",
  "Request A New Chain": "Richiedi una Nuova Catena",
  "Email is required": "L'email è obbligatoria",
  "Email is invaild": "L'email non è valida",
  "Model Required": "Modello Obbligatorio",
  "A Model is required": "È richiesto un modello",
  "Make Required": "Marca Obbligatoria",
  "A Make is required": "È richiesta una marca",
  "Chain Description": "Descrizione della Catena",
  "Edit Favourite": "Modifica Preferito",
  "Update Favourite": "Aggiorna Preferito",
  "Form Category": "Categoria Modulo",
  "Select Form Category": "Seleziona Categoria Modulo",
  "Machine": "Macchina",
  "Select Machine": "Seleziona Macchina",
  "Form Name": "Nome Modulo",
  "Select Form Name": "Seleziona Nome Modulo",
  "Select Inspector": "Seleziona Ispettore",
  "Select Custom Date Range": "Seleziona Intervallo Date Personalizzato",
  "Not Started": "Non Iniziato",
  "In Progress": "In Corso",
  "In Review": "In Revisione",
  "Completed": "Completato",
  "Attention Required": "Attenzione Richiesta",
  "Multiple Answers": "Risposte Multiple",
  "Comment Added": "Commento Aggiunto",
  "Show/Hide": "Mostra/Nascondi",
  "SerialNo": "Numero Seriale",
  "UnitNo": "Numero Unità",
  "SMU Difference": "Differenza SMU",
  "Serial no": "Numero Seriale",
  "Unit no": "Numero Unità",
  "SMR": "SMR",
  "Fail - Attention Required": "Errore - Attenzione Richiesta",
  "False/Unable to Answer - Immediate Action required": "Falso/Impossibile Rispondere - Azione Immediata Richiesta",
  "Report Options": "Opzioni Report",
  "Report Option": "Opzione Report",
  "Generate PDF": "Genera PDF",
  "In Progress/Completed": "In Corso/Completato",
  "Available Forms": "Moduli Disponibili",
  "Linked Models": "Modelli Collegati",
  "Linked Customers": "Clienti Collegati",
  "Start New": "Avvia Nuovo",
  "AVAILABLE FORMS": "MODULI DISPONIBILI",
  "Create New Form": "Crea Nuovo Modulo",
  "Copy": "Copia",
  "Edit Form": "Modifica Modulo",
  "Copy Form": "Copia Modulo",
  "Select Asset/System Type": "Seleziona Tipo di Asset/Sistema",
  "Select Asset Serial Number": "Seleziona Numero di Serie Asset",
  "Add Serial Number": "Aggiungi Numero di Serie",
  "Please use the Search field above to select what inspection you are shown.": "Utilizzare il campo di ricerca sopra per selezionare quali ispezioni visualizzare.",
  "Warranty Type Setup": "Configurazione Tipo di Garanzia",
  "Warranty Type": "Tipo di Garanzia",
  "Enter Warranty Type Name": "Inserisci Nome Tipo di Garanzia",
  "Include": "Includi",
  "Hours Usage": "Utilizzo Ore",
  "Enter Hours": "Inserisci Ore",
  "Enter Days": "Inserisci Giorni",
  "Cycles": "Cicli",
  "Enter Cycles": "Inserisci Cicli",
  "In-Active": "Inattivo",
  "Save/Update": "Salva/Aggiorna",
  "Product Improvement Program Search": "Ricerca Programma di Miglioramento Prodotto",
  "Select Build #": "Seleziona Build #",
  "Serial # Start": "Numero Seriale Iniziale",
  "Enter Serial # Start": "Inserisci Numero Seriale Iniziale",
  "Serial # End": "Numero Seriale Finale",
  "Enter Serial # End": "Inserisci Numero Seriale Finale",
  "PIP Number": "Numero PIP",
  "Enter Heading": "Inserisci Titolo",
  "Enter Heading Placeholder": "Inserisci Titolo",
  "Program Start Date": "Data Inizio Programma",
  "Program End Date": "Data Fine Programma",
  "PIP#": "PIP#",
  "Heading": "Titolo",
  "Built #": "Build #",
  "SN# Start": "SN# Iniziale",
  "SN# End": "SN# Finale",
  "Support Pro.": "Programma Supporto",
  "Show Less": "Mostra Meno",
  "Show More": "Mostra Di Più",
  "Asset SN#": "SN Asset",
  "Unit#": "Unità#",
  "Expired": "Scaduto",
  "Product Improvement Program": "Programa de Melhoria de Produto",
  "Return to Search Screen": "Retornar à Tela de Pesquisa",
  "Select Built #": "Selecionar Build #",
  "Enter PIP Number": "Digite o Número PIP",
  "Enter PIP Description": "Digite a Descrição do PIP",
  "Supporting Doc.": "Documento de Suporte",
  "Support Pro Associated with PIP": "Programa de Suporte Associado ao PIP",
  "Support Program Notes": "Notas do Programa de Suporte",
  "Enter Support Program Notes": "Digite as Notas do Programa de Suporte",
  "Generate Alert": "Gerar Alerta",
  "Select Warranty Type": "Seleziona Tipo di Garanzia",
  "Select Start Date": "Seleziona Data Iniziale",
  "Enter Starting SMU": "Inserisci SMU Iniziale",
  "Enter Starting Cycle #": "Inserisci Ciclo Iniziale #",
  "Set Default": "Imposta Predefinito",
  "Original Warranty": "Garanzia Originale",
  "Commencement Date": "Data di Inizio",
  "Commencement SMU": "SMU Iniziale",
  "Original CMU": "CMU Originale",
  "Residual Warranty": "Garanzia Residua",
  "Current Date": "Data Corrente",
  "Current SMU": "SMU Corrente",
  "Current Cycles": "Cicli Correnti",
  "Approval Request": "Richiesta di Approvazione",
  "Approval Response": "Risposta di Approvazione",
  "% Complete": "% Completato",
  "Total Hours ": "Ore Totali",
  "Total Cost ": "Costo Totale",
  "Product Improvement": "Miglioramento Prodotto",
  "PIP No": "Numero PIP",
  "Completed Date": "Data di Completamento",
  "PIP Notes": "Note PIP",
  "Open": "Aperto",
  "View Photo": "Visualizza Foto",
  "Replace Photo": "Sostituisci Foto",
  "Repairer": "Riparatore",
  "Implement Rebuild's Status": "Stato Ricostruzione Implemento",
  "Ready to Rebuild": "Pronto per Ricostruzione",
  "Pre Shipped": "Pre-Spedito",
  "Shipped": "Spedito",
  "Disassembled": "Smontato",
  "SOW-Approvals": "SOW-Approvazioni",
  "WIP": "Lavorazione in Corso",
  "Ready to Ship": "Pronto per la Spedizione",
  "Complete": "Completato",
  "Remove Component From Equipment": "Rimuovi Componente dall'Attrezzatura",
  "Create New Component": "Crea Nuovo Componente",
  "Clear History": "Cancella Storico",
  "Make Setup": "Configurazione Marca",
  "Select Existing Make": "Seleziona Marca Esistente",
  "Make Details": "Dettagli Marca",
  "Make ID": "ID Marca",
  "Enter Make ID": "Inserisci ID Marca",
  "Make Name": "Nome Marca",
  "Enter Make Name": "Inserisci Nome Marca",
  "OEM": "OEM",
  "Model Search": "Ricerca Modello",
  "Family Setup": "Configurazione Famiglia",
  "Select Existing Family": "Seleziona Famiglia Esistente",
  "Family Details": "Dettagli Famiglia",
  "Family ID": "ID Famiglia",
  "Family Name": "Nome Famiglia",
  "Family Image": "Immagine Famiglia",
  "Show Distance Travelled Tracking Option on Equipment Setup": "Mostra opzione distanza percorsa nella configurazione attrezzatura",
  "Show Propel Hours and % on Equipment": "Mostra ore propulsione e % sull'attrezzatura",
  "Enable Equaliser Bar Type Fields": "Abilita campi tipo barra equalizzatrice",
  "Enable Track Tension Indicator Installed Fields": "Abilita campi indicatore tensione cingolo",
  "Enable Frame Configuration": "Abilita configurazione telaio",
  "Enable Cannon Type": "Abilita tipo cannone",
  "Enable Bogie Shim": "Abilita spessore bogie",
  "Enable Manual Inspection Pdf": "Abilita PDF ispezione manuale",
  "Enable Track Sag": "Abilita abbassamento cingolo",
  "Enable Cannon Extension": "Abilita estensione cannone",
  "Enable Scallop": "Abilita scallop",
  "Enable Dry Joints": "Abilita giunti secchi",
  "Enable # of Links": "Abilita n° collegamenti",
  "Enable Under Foot Conditions": "Abilita condizioni sotto piede",
  "Enable Work Order": "Abilita ordine di lavoro",
  "Enable Thermal Image": "Abilita immagine termica",
  "Enable Additional Inspectors": "Abilita ispettori aggiuntivi",
  "Chain Image": "Immagine Catena",
  "Choose Chain Image": "Scegli immagine catena",
  "Frame Image": "Immagine Telaio",
  "Choose Frame Image": "Scegli immagine telaio",
  "Lookup": "Ricerca",
  "Job Role": "Ruolo Lavorativo",
  "Role Name": "Nome Ruolo",
  "Role Notes": "Note Ruolo",
  "Admin Role": "Ruolo Admin",
  "Update Roles": "Aggiorna Ruoli",
  "Update Permissions": "Aggiorna Permessi",
  "User Name": "Nome Utente",
  "Select the model you would like to view/edit": "Seleziona il modello da visualizzare/modificare",
  "No data available!": "Nessun dato disponibile!",
  "Model Details": "Dettagli Modello",
  "Model ID": "ID Modello",
  "Model Description": "Descrizione Modello",
  "Industry": "Industria",
  "Default Inspection Cycle": "Ciclo Ispezione Predefinito",
  "BaseModel": "Modello Base",
  "Model Note": "Nota Modello",
  "Component Detail": "Dettaglio Componente",
  "Upload to Mobile": "Carica su Mobile",
  "Chains Available": "Catene Disponibili",
  "Add Chain": "Aggiungi Catena",
  "# of Links": "N° Collegamenti",
  "No Of Links": "Numero Collegamenti",
  "Link Height": "Altezza Collegamento",
  "Number of Idlers": "Numero Tenditori",
  "Bolt Hole Diameter": "Diametro Foro Bullone",
  "Bushing Outside Diameter": "Diametro Esterno Boccola",
  "Number Of CarrierRollers": "Numero Rulli Superiori",
  "Chain Spread Inside": "Apertura Interna Catena",
  "Chain Spread Outside": "Apertura Esterna Catena",
  "Number Of TrackRollers": "Numero Rulli Cingolo",
  "Hardware": "Hardware",  
  "Berco Part Number": "Numero Parte Berco",
  "Case Part Number": "Numero Parte Case",
  "Quantity": "Quantità",
  "Part Line": "Linea Parte",
  "Component Details": "Dettagli Componente",
  "Component ID": "ID Componente",
  "Component Type Availability": "Disponibilità Tipo Componente",
  "Observation Details": "Dettagli Osservazione",
  "Mobile Screen Display of Observations:": "Visualizzazione osservazioni su schermo mobile:",
  "Equipment Conditions": "Condizioni Attrezzatura",
  "Components Screen": "Schermata Componenti",
  "Visibility": "Visibilità",
  "Update Limits": "Aggiorna Limiti",
  "Admin Role - allows edit functions in the equipment details screen": "Ruolo Admin - consente funzioni di modifica nella schermata dettagli attrezzatura",
  "Undercarriage Component Types": "Tipi Componenti Sottocarro",
  "Component Image": "Immagine Componente",
  "Component Family": "Famiglia Componente",
  "Component Type Name": "Nome Tipo Componente",
  "Information": "Informazione",
  "Please enter component extra details prior to sprocket hardware": "Inserire dettagli extra del componente prima dell'hardware del pignone",
  "Ok": "Ok",
  "Undercarriage Worn Limit Management": "Gestione Limiti di Usura Sottocarro",
  "Select Part #": "Seleziona Parte #",
  "Select Tool Used": "Seleziona Strumento Utilizzato",
  "High Impact": "Alto Impatto",
  "Low Impact": "Basso Impatto",
  "Comp. Type": "Tipo Comp.",
  "Part #": "Parte #",
  "Method": "Metodo",
  "Tool Used": "Strumento Utilizzato",
  "Slope": "Pendenza",
  "Adjust to Base": "Regola alla Base",
  "Inflect Pt.": "Punto Inflessione",
  "Slope1": "Pendenza1",
  "Y Int.1": "Intercetta Y1",
  "Slope2": "Pendenza2",
  "Y Int.2": "Intercetta Y2",
  "Starting Dim": "Dimensione Iniziale",
  "100% Worn": "100% Usurato",
  "No records to display.": "Nessun record da visualizzare.",
  "New High": "Nuovo Alto",
  "New Low": "Nuovo Basso",
  "Polynomial Worn Limits": "Limiti di Usura Polinomiali",
  "Impact 2nd Order": "Impatto 2° Ordine",
  "Normal 2nd Order": "Normale 2° Ordine",
  "Impact Slope": "Pendenza Impatto",
  "Normal Slope": "Pendenza Normale",
  "Impact Intercept": "Intercetta Impatto",
  "Normal Intercept": "Intercetta Normale",
  "Linear Worn Limits": "Limiti di Usura Lineari",
  "Worn Limit Setup": "Configurazione Limiti di Usura",
  "Method of Calculation": "Metodo di Calcolo",
  "Tools": "Strumenti",
  "U/C Make": "Marca U/C",
  "Adjustment to Base": "Regolazione Base",
  "H.I. - Inflection Point": "H.I. - Punto Inflessione",
  "M.I. - Inflection Point": "M.I. - Punto Inflessione",
  "H.I. - Slope 1": "H.I. - Pendenza 1",
  "M.I. - Slope 1": "M.I. - Pendenza 1",
  "H.I. -Y Intercept 1": "H.I. - Intercetta Y 1",
  "M.I. -Y Intercept 1": "M.I. - Intercetta Y 1",
  "H.I. - Slope 2": "H.I. - Pendenza 2",
  "M.I. - Slope 2": "M.I. - Pendenza 2",
  "H.I. -Y Intercept 2": "H.I. - Intercetta Y 2",
  "M.I. -Y Intercept 2": "M.I. - Intercetta Y 2",
  "Worn Dimension": "Dimensione Usura",
  "Impact": "Impatto",
  "Start Depth.New": "Profondità Iniziale.Nuova",
  "Wear Depth": "Profondità Usura",
  "Normal": "Normale",
  "Slope Direction - Impact": "Direzione Pendenza - Impatto",
  "Slope Direction - Normal": "Direzione Pendenza - Normale",
  "Add New Limit": "Aggiungi Nuovo Limite",
  "Worn Spec": "Specifica di Usura",
  "Tolerance": "Tolleranza",
  "Plus": "Più",
  "Minus": "Meno",
  "Max": "Massimo",
  "Add Measurement Image": "Aggiungi Immagine Misurazione",
  "Tool Name": "Nome Strumento",
  "Currently applying to": "Attualmente applicato a",
  "selected machines": "macchine selezionate",
  "For your selection the system is currently using the default ranges. These are shown below": "Per la selezione effettuata il sistema sta utilizzando gli intervalli predefiniti. Sono mostrati di seguito",
  "For your selection site default limits display.These are shown below.": "Per la selezione effettuata vengono mostrati i limiti predefiniti del sito.",
  "Limit display for selected machine.": "Visualizzazione limiti per la macchina selezionata.",
  "For your selection the system is currently using the dealer ranges. These are shown below": "Per la selezione effettuata il sistema sta utilizzando gli intervalli del concessionario. Sono mostrati di seguito",
  "For your selection the system is currently using the customer ranges. These are shown below": "Per la selezione effettuata il sistema sta utilizzando gli intervalli del cliente. Sono mostrati di seguito",
  "Create New Measurement Point": "Crea Nuovo Punto di Misurazione",
  "Rope Shovel/Hydraulic Shovel": "Pala a Fune/Pala Idraulica",
  "URC": "URC",
  "Component Note": "Nota Componente",
  "SMCS Job Code": "Codice Lavoro SMCS",
  "Budget Life (Hours)": "Vita Stimata (Ore)",
  "Populate from USCO": "Compila da USCO",
  "Component Make": "Marca Componente",
  "Measurement Images": "Immagini Misurazione",
  "Unit number": "Numero Unità",
  "Level": "Livello",
  "Default Tool": "Strumento Predefinito",
  "Select a Default Tool": "Seleziona uno Strumento Predefinito",
  "Please Select a default tool": "Seleziona uno strumento predefinito",
  "True": "Vero",
  "False": "Falso",
  "Inspection Type cannot exceed 50 characters.": "Il tipo di ispezione non può superare 50 caratteri.",
  "Standard Cost Repair": "Costo Standard Riparazione",
  "Standard Hours Repair": "Ore Standard Riparazione",
  "You can attach a photo of this measurement point ": "Puoi allegare una foto di questo punto di misurazione",
  "Add Measurement Points": "Aggiungi Punti di Misurazione",
  "Copy Obs. Pts.": "Copia Punti Oss.",
  "Add Dealer Group Branded Style": "Aggiungi Stile Brandizzato del Gruppo Concessionario",
  "Select Dealer Group": "Seleziona Gruppo Concessionario",
  "Colour Scheme": "Schema Colori",
  "Select Colour Scheme": "Seleziona Schema Colori",
  "Upload a logo for the Dealer Group. Recommended 77px by 35px.": "Carica un logo per il Gruppo Concessionario. Consigliato 77px per 35px.",
  "Update Branded Style": "Aggiorna Stile Brandizzato",
  "Select Filters to display and edit data": "Seleziona Filtri per visualizzare e modificare i dati",
  "Component Setup": "Configurazione Componenti",
  "Component Search": "Ricerca Componenti",
  "Equipment Make": "Marca Attrezzatura",
  "Equipment Model": "Modello Attrezzatura",
  "Default Tool Used": "Strumento Predefinito Utilizzato",
  "Search and Review Forms": "Cerca e Rivedi Moduli",
  "Enter Safety Inspection - Web Browser": "Inserisci Ispezione di Sicurezza - Browser Web",
  "Search Safety Inspections": "Cerca Ispezioni di Sicurezza",
  "Upload Completed Forms": "Carica Moduli Completati",
  "Configuration": "Configurazione",
  "Add Take 5's": "Aggiungi Take 5",
  "Add Toolbox Talk": "Aggiungi Toolbox Talk",
  "Add Monthly Dashboard Message": "Aggiungi Messaggio Mensile Dashboard",
  "View/Edit Monthly Hours": "Visualizza/Modifica Ore Mensili",
  "Setup Induction Slides": "Configura Slide di Induzione",
  "Setup Induction Questions": "Configura Domande di Induzione",
  "Setup Induction Types and Sections": "Configura Tipi e Sezioni di Induzione",
  "Safety Inspections": "Ispezioni di Sicurezza",
  "Setup Departments/Work Areas": "Configura Reparti/Aree di Lavoro",
  "Setup Safety Checklist": "Configura Checklist Sicurezza",
  "Setup Digital Forms": "Configura Moduli Digitali",
  "All State": "Tutti gli Stati",
  "All States": "Tutti gli Stati",
  "Checks Completed": "Controlli Completati",
  "Current Count": "Conteggio Attuale",
  "Target for Month": "Obiettivo del Mese",
  "Target for Date": "Obiettivo per la Data",
  "Checks with Fails": "Controlli con Errori",
  "Failed Items": "Elementi Falliti",
  "Since Last Fail": "Dall'Ultimo Errore",
  "Incident Counts": "Conteggio Incidenti",
  "Last MTI": "Ultimo MTI",
  "Last LTI": "Ultimo LTI",
  "Focus Items": "Elementi di Focus",
  "Take 5's for Period": "Take 5 del Periodo",
  "Target": "Obiettivo",
  "Actual": "Effettivo",
  "Previous 12 Mths Hours": "Ore Ultimi 12 Mesi",
  "Previous 12 Mths TRIFR": "TRIFR Ultimi 12 Mesi",
  "Last 12 Months": "Ultimi 12 Mesi",
  "Areas of Improvements": "Aree di Miglioramento",
  "Positives": "Aspetti Positivi",
  "Activities": "Attività",
  "Incidents": "Incidenti",
  "Observation Type": "Tipo di Osservazione",
  "Work Area": "Area di Lavoro",
  "Office": "Ufficio",
  "Month-Year": "Mese-Anno",
  "January": "Gennaio",
  "March": "Marzo",
  "April": "Aprile",
  "June": "Giugno",
  "July": "Luglio",
  "August": "Agosto",
  "September": "Settembre",
  "October": "Ottobre",
  "November": "Novembre",
  "December": "Dicembre",
  "Month": "Mese",
  "Year": "Anno",
  "Number": "Numero",
  "Add New Observation": "Aggiungi Nuova Osservazione",
  "Department": "Dipartimento",
  "Task Observed": "Attività Osservata",
  "Setup Departments": "Configura Dipartimenti",
  "Add Work Area": "Aggiungi Area di Lavoro",
  "Add Department": "Aggiungi Dipartimento",
  "Incident Types": "Tipi di Incidente",
  "Add Incident Type": "Aggiungi Tipo di Incidente",
  "Setup Questions": "Configura Domande",
  "Add Question": "Aggiungi Domanda",
  "Add New Category": "Aggiungi Nuova Categoria",
  "Add Induction Type": "Aggiungi Tipo di Induzione",
  "Induction Type": "Tipo di Induzione",
  "Add Slide": "Aggiungi Slide",
  "Safety Observation Search": "Ricerca Osservazioni di Sicurezza",
  "Select Work Area": "Seleziona Area di Lavoro",
  "Select Category": "Seleziona Categoria",
  "Select Department": "Seleziona Dipartimento",
  "Select Contractor": "Seleziona Appaltatore",
  "Select Question": "Seleziona Domanda",
  "Supplier": "Fornitore",
  "Follow Up Required": "Follow-up Richiesto",
  "Follow Up Completed": "Follow-up Completato",
  "Only Unsafe": "Solo Non Sicuro",
  "Exclude N/A": "Escludi N/D",
  "Only Inspections": "Solo Ispezioni",
  "Show Department": "Mostra Dipartimento",
  "Show Work Area": "Mostra Area di Lavoro",
  "Show Observer": "Mostra Osservatore",
  "Category": "Categoria",
  "Safe/Unsafe": "Sicuro/Non Sicuro",
  "Unsafe": "Non Sicuro",
  "Safe": "Sicuro",
  "Observer": "Osservatore",
  "No Data Found for this search criteria.": "Nessun dato trovato per questo criterio di ricerca.",
  "Induction": "Induzione",
  "Select Induction Type": "Seleziona Tipo di Induzione",
  "Select State": "Seleziona Stato",
  "Facilitator": "Facilitatore",
  "User (Already setup) being Inducted": "Utente (già configurato) in induzione",
  "User (Not setup) being Inducted": "Utente (non configurato) in induzione",
  "Start": "Avvia",
  "Slide": "Slide",
  "Ans": "Risposta",
  "Issue Start Date": "Data Inizio Emissione",
  "Issue End Date": "Data Fine Emissione",
  "Document Heading": "Titolo Documento",
  "Date Issued": "Data di Emissione",
  "Expiry Date": "Data di Scadenza",
  "Field Changed": "Campo Modificato",
  "From": "Da",
  "To": "A",
  "New Leave Request": "Nuova Richiesta di Congedo",
  "Update Leave Request": "Aggiorna Richiesta di Congedo",
  "Leave Requests": "Richieste di Congedo",
  "Leave Administration": "Amministrazione Congedi",
  "Leave Type": "Tipo di Congedo",
  "Leave From": "Congedo Dal",
  "Leave To": "Congedo Al",
  "Attach Doc.": "Allega Documento",
  "Attachment": "Allegato",
  "Administration By": "Amministrato Da",
  "Approved By": "Approvato Da",
  "Requested User": "Utente Richiedente",
  "Field Change": "Modifica Campo",
  "Filter user": "Filtra utente",
  "Filter customer": "Filtra cliente",
  "Filter job site": "Filtra sito di lavoro",
  "Filter dealership": "Filtra concessionaria",
  "Filter dealer group": "Filtra gruppo concessionarie",
  "Pending": "In Attesa",
  "Cancel Invite": "Annulla Invito",
  "Support Team Access": "Accesso Team di Supporto",
  "Dealer Group Access": "Accesso Gruppo Concessionarie",
  "Dealer Access": "Accesso Concessionaria",
  "Customer Access": "Accesso Cliente",
  "Jobsite Access": "Accesso Sito di Lavoro",
  "Equipment Access": "Accesso Attrezzatura",
  "Reset Password": "Reimposta Password",
  "Contact Email": "Email di Contatto",
  "Job Sites/th": "Siti di Lavoro",
  "Dealership": "Concessionaria",
  "Dealership Name": "Nome Concessionaria",
  "Safety Observation Dashboard": "Dashboard Osservazioni Sicurezza",
  "Safety General Dashboard": "Dashboard Generale Sicurezza",
  "Add Monthly Dashboard Messages": "Aggiungi Messaggi Mensili Dashboard",
  "Select a Form": "Seleziona un Modulo",
  "Report / Incident # required": "Rapporto / N° Incidente richiesto",
  "Digital Form": "Modulo Digitale",
  "Add Form": "Aggiungi Modulo",
  "Add Form Category": "Aggiungi Categoria Modulo",
  "Upload Forms": "Carica Moduli",
  "Add File(s)": "Aggiungi File",
  "Related User": "Utente Correlato",
  "Add Image(s)": "Aggiungi Immagini",
  "Report/Incident ID": "ID Rapporto/Incidente",
  "Incident Type": "Tipo di Incidente",
  "Follow Up Date": "Data Follow Up",
  "Follow Up User": "Utente Follow Up",
  "Form Search": "Ricerca Moduli",
  "Date Start": "Data Inizio",
  "Date End": "Data Fine",
  "Form": "Modulo",
  "Person Responsible": "Responsabile",
  "Due Date Start": "Data Scadenza Inizio",
  "Due Date End": "Data Scadenza Fine",
  "Suspended User": "Utente Sospeso",
  "Suspended Related Users": "Utenti Correlati Sospesi",
  "Archived Forms": "Moduli Archiviati",
  "Active Forms": "Moduli Attivi",
  "Form Type": "Tipo di Modulo",
  "Add to Archive": "Aggiungi ad Archivio",
  "All Positions": "Tutte le Posizioni",
  "All Forms": "Tutti i Moduli",
  "All Users": "Tutti gli Utenti",
  "Date Completed": "Data Completata",
  "Induction Search": "Ricerca Induzione",
  "First Name": "Nome",
  "Last Name": "Cognome",
  "Company": "Azienda",
  "Show Valid": "Mostra Validi",
  "Show Invalid": "Mostra Non Validi",
  "No Data Found - Please reset and try again.": "Nessun dato trovato. Reimposta e riprova.",
  "VALID": "VALIDO",
  "Focus Item": "Elemento Focus",
  "Areas Of Improvement": "Aree di Miglioramento",
  "Take 5 target": "Obiettivo Take 5",
  "Safety Inspection target": "Obiettivo Ispezione Sicurezza",
  "Take 5 Target": "Obiettivo Take 5",
  "Safety Inspection Target": "Obiettivo Ispezione Sicurezza",
  "Select Equipment for Hire Report": "Seleziona Attrezzatura per Rapporto di Noleggio",
  "Idler Setup": "Configurazione Rullo Tenditore",
  "Idler From Inventory": "Rullo Tenditore da Inventario",
  "Chain Setup": "Configurazione Catena",
  "Chain From Inventory": "Catena da Inventario",
  "Frame Setup": "Configurazione Telaio",
  "Frame From Inventory": "Telaio da Inventario",
  "Add New Inspection": "Aggiungi Nuova Ispezione",
  "Additional Component Setup": "Configurazione Componente Aggiuntivo",
  "Additional Component Selection": "Selezione Componente Aggiuntivo",
  "Additional Component Details": "Dettagli Componente Aggiuntivo",
  "Select the component you would like to edit the measurement points for": "Seleziona il componente per cui desideri modificare i punti di misurazione",
  "Model Image": "Immagine Modello",
  "Model Image Left": "Immagine Modello Sinistra",
  "Model Image Right": "Immagine Modello Destra",
  "Average wear rates used in Forecasting": "Tassi medi di usura utilizzati nelle previsioni",
  "Base Model": "Modello Base",
  "Compart": "Compartimento",
  "Search Document in Library": "Cerca Documento nella Libreria",
  "Select Doc. Type": "Seleziona Tipo Documento",
  "Select Doc. Status": "Seleziona Stato Documento",
  "Select End Date": "Seleziona Data Fine",
  "Doc. Type": "Tipo Documento",
  "Add Document in Library": "Aggiungi Documento alla Libreria",
  "Edit Document in Library": "Modifica Documento nella Libreria",
  "Automatically Add to Assets defined by above selection criteria": "Aggiungi automaticamente alle risorse definite dai criteri di selezione sopra indicati",
  "Additional Component Name": "Nome Componente Aggiuntivo",
  "Select System": "Seleziona Sistema",
  "No System": "Nessun Sistema",
  "No Side": "Nessun Lato",
  "Please select a Model": "Seleziona un Modello",
  "Apply Models...": "Applica Modelli...",
  "You can attach a photo.": "Puoi allegare una foto.",
  "JobSite": "Sito di Lavoro",  
  "Is Bogie": "È Bogie",
  "UC Planner": "Pianificatore Sottocarro",
  "SMU & PMU Input": "Inserimento SMU e PMU",
  "Search URC": "Cerca URC",
  "New Undercarriage Rebuild Center": "Nuovo Centro di Ricostruzione del Sottocarro",
  "MidPoint %":"Punto medio %",
  'Inspection Document Register': 'Registro Documenti di Ispezione',
  'Include in Report (PDFs Only)': 'Includi nel Report (Solo PDF)',
  'Attachments': 'Allegati',
  'Select Date': 'Seleziona Data',
  'Select Document Type': 'Seleziona Tipo di Documento',
  "Training Center": "Centro di Formazione",
  "All Topics": "Tutti gli Argomenti",
  "Filter by Topic": "Filtra per Argomento",
  "Edit Additional Observation": "Modifica Osservazione Aggiuntiva",
  'User Preferences ': 'Preferenze Utente',
  "Parts Search": "Ricerca di pezzi",
  "Report Name": "Nome del rapporto",
  "Forecast Seasonal Date Ranges": "Intervalli di date stagionali previste",
  "Season": "Stagione",
  "Wear Rate": "Tasso di usura",
};